import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7073/Campaigns";
	}
	addOrUpdateDocument(e, t, r, i, a, o) {
		let s = this.baseUrl + "/AddOrUpdateDocument";
		if (s += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (s += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'documentType' must be defined and cannot be null.");
		s += "documentType=" + encodeURIComponent(f(t)) + "&", i != null && (s += "contractId=" + encodeURIComponent(f(i)) + "&"), a != null && (s += "filePath=" + encodeURIComponent(f(a)) + "&"), s = s.replace(/[?&]$/, "");
		let c = new FormData();
		for (let [e, t] of Object.entries(r ?? {})) t != null && c.append(e, t instanceof Blob ? t : String(t));
		let l = {
			method: "POST",
			url: s,
			headers: { Accept: "application/json" },
			data: c,
			signal: o
		};
		return this.transformOptions(l).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(s, e, (e) => this.processAddOrUpdateDocument(e)));
	}
	processAddOrUpdateDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	beginCampaign(e, t) {
		let r = this.baseUrl + "/BeginCampaign", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processBeginCampaign(e)));
	}
	processBeginCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	completeCampaignStep(e, t) {
		let r = this.baseUrl + "/CompleteCampaignStep", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCompleteCampaignStep(e)));
	}
	processCompleteCampaignStep(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	constructConditionClauseText(e, t) {
		let r = this.baseUrl + "/ConstructConditionClauseText", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processConstructConditionClauseText(e)));
	}
	processConstructConditionClauseText(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	convertAgentExchangeToSalesAdvice(e, t) {
		let r = this.baseUrl + "/ConvertAgentExchangeToSalesAdvice", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processConvertAgentExchangeToSalesAdvice(e)));
	}
	processConvertAgentExchangeToSalesAdvice(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	convertSalesAdviceToAgentExchange(e, t) {
		let r = this.baseUrl + "/ConvertSalesAdviceToAgentExchange", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processConvertSalesAdviceToAgentExchange(e)));
	}
	processConvertSalesAdviceToAgentExchange(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	devCreateContractTestCampaign(e, t) {
		let r = this.baseUrl + "/DevCreateContractTestCampaign", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDevCreateContractTestCampaign(e)));
	}
	processDevCreateContractTestCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	exchangeContract(e, t) {
		let r = this.baseUrl + "/ExchangeContract", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processExchangeContract(e)));
	}
	processExchangeContract(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	formsByLocations(e) {
		let t = this.baseUrl + "/FormsByLocations", r = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processFormsByLocations(e)));
	}
	processFormsByLocations(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getActiveCampaigns(e) {
		let t = this.baseUrl + "/GetActiveCampaigns", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetActiveCampaigns(e)));
	}
	processGetActiveCampaigns(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgreementReadiness(e, t, r) {
		let i = this.baseUrl + "/GetAgreementReadiness";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", t != null && (i += "formId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetAgreementReadiness(e)));
	}
	processGetAgreementReadiness(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of Any", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? J("Payload of AgreementReadinessError", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getArchivedCampaignsByAdmin(e, t) {
		let r = this.baseUrl + "/GetArchivedCampaignsByAdmin";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetArchivedCampaignsByAdmin(e)));
	}
	processGetArchivedCampaignsByAdmin(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getArchivedCampaignsByAgency(e) {
		let t = this.baseUrl + "/GetArchivedCampaignsByAgency", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetArchivedCampaignsByAgency(e)));
	}
	processGetArchivedCampaignsByAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCampaign(e, t) {
		let r = this.baseUrl + "/GetCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCampaign(e)));
	}
	processGetCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCampaignsForAgency(e, t) {
		let r = this.baseUrl + "/GetCampaignsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCampaignsForAgency(e)));
	}
	processGetCampaignsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getProposalPresentationDetails(e, t) {
		let r = this.baseUrl + "/GetProposalPresentationDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetProposalPresentationDetails(e)));
	}
	processGetProposalPresentationDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getProposalPresentationSources(e, t) {
		let r = this.baseUrl + "/GetProposalPresentationSources";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetProposalPresentationSources(e)));
	}
	processGetProposalPresentationSources(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getSpecialConditionBank(e) {
		let t = this.baseUrl + "/GetSpecialConditionBank", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetSpecialConditionBank(e)));
	}
	processGetSpecialConditionBank(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUploadedFileLink(e, t) {
		let r = this.baseUrl + "/GetUploadedFileLink";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		r += "filePath=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUploadedFileLink(e)));
	}
	processGetUploadedFileLink(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	importProposalImage(e, t) {
		let r = this.baseUrl + "/ImportProposalImage", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processImportProposalImage(e)));
	}
	processImportProposalImage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? J("No description", e.status, e.data, t) : e.status === 404 || e.status === 502 || e.status === 504 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	loadForm(e, t, r) {
		let i = this.baseUrl + "/LoadForm";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'formId' must be defined and cannot be null.");
		i += "formId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processLoadForm(e)));
	}
	processLoadForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	negotiate(e) {
		let t = this.baseUrl + "/Negotiate", r = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processNegotiate(e)));
	}
	processNegotiate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	performCampaignAction(e, t) {
		let r = this.baseUrl + "/PerformCampaignAction", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processPerformCampaignAction(e)));
	}
	processPerformCampaignAction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	performContractAction(e, t) {
		let r = this.baseUrl + "/PerformContractAction", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processPerformContractAction(e)));
	}
	processPerformContractAction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	removeFile(e, t) {
		let r = this.baseUrl + "/RemoveFile", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemoveFile(e)));
	}
	processRemoveFile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	removeFormSubmission(e, t) {
		let r = this.baseUrl + "/RemoveFormSubmission", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemoveFormSubmission(e)));
	}
	processRemoveFormSubmission(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	saveForm(e, t) {
		let r = this.baseUrl + "/SaveForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSaveForm(e)));
	}
	processSaveForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 409 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	sendForm(e, t) {
		let r = this.baseUrl + "/SendForm", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSendForm(e)));
	}
	processSendForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	setCampaignOwnership(e, t) {
		let r = this.baseUrl + "/SetCampaignOwnership", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetCampaignOwnership(e)));
	}
	processSetCampaignOwnership(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffBeginCampaign(e, t) {
		let r = this.baseUrl + "/StaffBeginCampaign", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffBeginCampaign(e)));
	}
	processStaffBeginCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateContractDepositRelease(e, t, r, i) {
		let a = this.baseUrl + "/StaffCreateContractDepositRelease";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffCreateContractDepositRelease(e)));
	}
	processStaffCreateContractDepositRelease(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 || e.status === 409 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAgreementDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetAgreementDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetAgreementDetailsForCampaign(e)));
	}
	processStaffGetAgreementDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBlankContractDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetBlankContractDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBlankContractDetailsForCampaign(e)));
	}
	processStaffGetBlankContractDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBuyers(e, t) {
		let r = this.baseUrl + "/StaffGetBuyers";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBuyers(e)));
	}
	processStaffGetBuyers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBuyersAgent(e, t) {
		let r = this.baseUrl + "/StaffGetBuyersAgent";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBuyersAgent(e)));
	}
	processStaffGetBuyersAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBuyersSolicitor(e, t) {
		let r = this.baseUrl + "/StaffGetBuyersSolicitor";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBuyersSolicitor(e)));
	}
	processStaffGetBuyersSolicitor(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetCampaign(e)));
	}
	processStaffGetCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCampaignDashboard(e, t, r, i, a, o, s, c, l, u, d) {
		let p = this.baseUrl + "/StaffGetCampaignDashboard";
		if (p += "?", e != null) for (let t of e) p += "agencyIds=" + encodeURIComponent(f(t)) + "&";
		if (t != null) for (let e of t) p += "states=" + encodeURIComponent(f(e)) + "&";
		if (r != null) for (let e of r) p += "campaignStatuses=" + encodeURIComponent(f(e)) + "&";
		if (i != null) for (let e of i) p += "launchDateStatuses=" + encodeURIComponent(f(e)) + "&";
		if (a != null) for (let e of a) p += "marketingStatuses=" + encodeURIComponent(f(e)) + "&";
		if (o != null) for (let e of o) p += "blankContractStatuses=" + encodeURIComponent(f(e)) + "&";
		s != null && (p += "addressSearch=" + encodeURIComponent(f(s)) + "&"), c != null && (p += "continuationToken=" + encodeURIComponent(f(c)) + "&"), l != null && (p += "pageSize=" + encodeURIComponent(f(l)) + "&"), u != null && (p += "sortingOption=" + encodeURIComponent(f(u)) + "&"), p = p.replace(/[?&]$/, "");
		let m = {
			method: "GET",
			url: p,
			headers: { Accept: "application/json" },
			signal: d
		};
		return this.transformOptions(m).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(p, e, (e) => this.processStaffGetCampaignDashboard(e)));
	}
	processStaffGetCampaignDashboard(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCampaignOverview(e, t) {
		let r = this.baseUrl + "/StaffGetCampaignOverview";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetCampaignOverview(e)));
	}
	processStaffGetCampaignOverview(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCommissionInfoForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetCommissionInfoForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetCommissionInfoForCampaign(e)));
	}
	processStaffGetCommissionInfoForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContract(e, t) {
		let r = this.baseUrl + "/StaffGetContract";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContract(e)));
	}
	processStaffGetContract(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractDashboard(e, t, r, i, a, o, s, c) {
		let l = this.baseUrl + "/StaffGetContractDashboard";
		if (l += "?", e != null) for (let t of e) l += "agencyIds=" + encodeURIComponent(f(t)) + "&";
		if (t != null) for (let e of t) l += "states=" + encodeURIComponent(f(e)) + "&";
		if (r != null) for (let e of r) l += "contractStatuses=" + encodeURIComponent(f(e)) + "&";
		if (i != null) for (let e of i) l += "settlementDateStatuses=" + encodeURIComponent(f(e)) + "&";
		if (a != null) for (let e of a) l += "vendorBankDetailsStatuses=" + encodeURIComponent(f(e)) + "&";
		o != null && (l += "addressSearch=" + encodeURIComponent(f(o)) + "&"), s != null && (l += "sortingOptionContractDashboard=" + encodeURIComponent(f(s)) + "&"), l = l.replace(/[?&]$/, "");
		let u = {
			method: "GET",
			url: l,
			headers: { Accept: "application/json" },
			signal: c
		};
		return this.transformOptions(u).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(l, e, (e) => this.processStaffGetContractDashboard(e)));
	}
	processStaffGetContractDashboard(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractDates(e, t, r) {
		let i = this.baseUrl + "/StaffGetContractDates";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetContractDates(e)));
	}
	processStaffGetContractDates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractDeposits(e, t, r) {
		let i = this.baseUrl + "/StaffGetContractDeposits";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetContractDeposits(e)));
	}
	processStaffGetContractDeposits(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractSettlement(e, t, r) {
		let i = this.baseUrl + "/StaffGetContractSettlement";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetContractSettlement(e)));
	}
	processStaffGetContractSettlement(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetContractsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractsForCampaign(e)));
	}
	processStaffGetContractsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetDocumentsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetDocumentsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetDocumentsForCampaign(e)));
	}
	processStaffGetDocumentsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetExternalConjunction(e, t) {
		let r = this.baseUrl + "/StaffGetExternalConjunction";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetExternalConjunction(e)));
	}
	processStaffGetExternalConjunction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetFormConfiguration(e, t) {
		let r = this.baseUrl + "/StaffGetFormConfiguration", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetFormConfiguration(e)));
	}
	processStaffGetFormConfiguration(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetLaunchDateDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetLaunchDateDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetLaunchDateDetailsForCampaign(e)));
	}
	processStaffGetLaunchDateDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPhotosAndMediaDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetPhotosAndMediaDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffGetPhotosAndMediaDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPropertyDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetPropertyDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPropertyDetailsForCampaign(e)));
	}
	processStaffGetPropertyDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPropertyInformationProgressForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetPropertyInformationProgressForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPropertyInformationProgressForCampaign(e)));
	}
	processStaffGetPropertyInformationProgressForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetSaleInformation(e, t, r) {
		let i = this.baseUrl + "/StaffGetSaleInformation";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetSaleInformation(e)));
	}
	processStaffGetSaleInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetSpecialConditions(e, t, r) {
		let i = this.baseUrl + "/StaffGetSpecialConditions";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", t != null && (i += "contractId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetSpecialConditions(e)));
	}
	processStaffGetSpecialConditions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetTenancyInformationForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetTenancyInformationForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetTenancyInformationForCampaign(e)));
	}
	processStaffGetTenancyInformationForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetUploadedFileLink(e, t) {
		let r = this.baseUrl + "/StaffGetUploadedFileLink";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		r += "filePath=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "text/plain" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetUploadedFileLink(e)));
	}
	processStaffGetUploadedFileLink(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetVendorDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetVendorDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetVendorDetailsForCampaign(e)));
	}
	processStaffGetVendorDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffPreviewLinkedDates(e, t, r, i) {
		let a = this.baseUrl + "/StaffPreviewLinkedDates";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffPreviewLinkedDates(e)));
	}
	processStaffPreviewLinkedDates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSaveForm(e, t) {
		let r = this.baseUrl + "/StaffSaveForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSaveForm(e)));
	}
	processStaffSaveForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSearchForCampaign(e, t, r, i, a) {
		let o = this.baseUrl + "/StaffSearchForCampaign";
		if (o += "?", e == null) throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
		if (o += "searchTerm=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'searchForArchived' must be defined and cannot be null.");
		o += "searchForArchived=" + encodeURIComponent(f(t)) + "&", r != null && (o += "resultType=" + encodeURIComponent(f(r)) + "&"), i != null && (o += "continuationToken=" + encodeURIComponent(f(i)) + "&"), o = o.replace(/[?&]$/, "");
		let s = {
			method: "GET",
			url: o,
			headers: { Accept: "application/json" },
			signal: a
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processStaffSearchForCampaign(e)));
	}
	processStaffSearchForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSubmitForm(e, t) {
		let r = this.baseUrl + "/StaffSubmitForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSubmitForm(e)));
	}
	processStaffSubmitForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateAgreementDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateAgreementDetailsForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateAgreementDetailsForCampaign(e)));
	}
	processStaffUpdateAgreementDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBlankContractDetailsForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBlankContractDetailsForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBlankContractDetailsForCampaign(e)));
	}
	processStaffUpdateBlankContractDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBuyers(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBuyers";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBuyers(e)));
	}
	processStaffUpdateBuyers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBuyersAgent(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBuyersAgent";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBuyersAgent(e)));
	}
	processStaffUpdateBuyersAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBuyersSolicitor(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBuyersSolicitor";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBuyersSolicitor(e)));
	}
	processStaffUpdateBuyersSolicitor(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateCommissionInfoForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateCommissionInfoForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateCommissionInfoForCampaign(e)));
	}
	processStaffUpdateCommissionInfoForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractComplianceFields(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractComplianceFields";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractComplianceFields(e)));
	}
	processStaffUpdateContractComplianceFields(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractDates(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractDates";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractDates(e)));
	}
	processStaffUpdateContractDates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractDeposits(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractDeposits";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractDeposits(e)));
	}
	processStaffUpdateContractDeposits(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractSettlement(e, t, r, i) {
		let a = this.baseUrl + "/StaffUpdateContractSettlement";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffUpdateContractSettlement(e)));
	}
	processStaffUpdateContractSettlement(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractSpecialConditionDueDate(e, t) {
		let r = this.baseUrl + "/StaffUpdateContractSpecialConditionDueDate", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractSpecialConditionDueDate(e)));
	}
	processStaffUpdateContractSpecialConditionDueDate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractSpecialConditions(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractSpecialConditions";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractSpecialConditions(e)));
	}
	processStaffUpdateContractSpecialConditions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractTermination(e, t, r, i) {
		let a = this.baseUrl + "/StaffUpdateContractTermination";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffUpdateContractTermination(e)));
	}
	processStaffUpdateContractTermination(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of StaffUpdateModel", e.status, e.data, t, e.data) : e.status === 403 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateExternalConjunction(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateExternalConjunction";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateExternalConjunction(e)));
	}
	processStaffUpdateExternalConjunction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateLaunchDateForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateLaunchDateForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateLaunchDateForCampaign(e)));
	}
	processStaffUpdateLaunchDateForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdatePhotosAndMediaDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdatePhotosAndMediaDetailsForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdatePhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffUpdatePhotosAndMediaDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 || e.status === 409 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdatePropertyDetailsForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdatePropertyDetailsForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdatePropertyDetailsForCampaign(e)));
	}
	processStaffUpdatePropertyDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateSaleInformation(e, t, r, i) {
		let a = this.baseUrl + "/StaffUpdateSaleInformation";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffUpdateSaleInformation(e)));
	}
	processStaffUpdateSaleInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateServiceFeeInfoForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateServiceFeeInfoForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateServiceFeeInfoForCampaign(e)));
	}
	processStaffUpdateServiceFeeInfoForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateTenancyInformationForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateTenancyInformationForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateTenancyInformationForCampaign(e)));
	}
	processStaffUpdateTenancyInformationForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateVendorDetailsForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateVendorDetailsForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateVendorDetailsForCampaign(e)));
	}
	processStaffUpdateVendorDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffWithdrawContractOffer(e, t, r, i) {
		let a = this.baseUrl + "/StaffWithdrawContractOffer";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffWithdrawContractOffer(e)));
	}
	processStaffWithdrawContractOffer(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of StaffUpdateModel", e.status, e.data, t, e.data) : e.status === 403 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	submitForm(e, t) {
		let r = this.baseUrl + "/SubmitForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSubmitForm(e)));
	}
	processSubmitForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateProposalPresentationDetails(e, t) {
		let r = this.baseUrl + "/UpdateProposalPresentationDetails", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateProposalPresentationDetails(e)));
	}
	processUpdateProposalPresentationDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 409 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Property = "Property", e.Vendors = "Vendors", e.Pricing = "Pricing", e.Marketing = "Marketing", e.Commission = "Commission", e.StateDisclosures = "StateDisclosures", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Ready = "Ready", e.Missing = "Missing", e.NeedsReview = "NeedsReview", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.ListingProposal = "ListingProposal", e.Agreement = "Agreement", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.UnsupportedState = "UnsupportedState", e.InvalidFormType = "InvalidFormType", e.FeatureDisabled = "FeatureDisabled", e.AccessDenied = "AccessDenied", e.CampaignNotFound = "CampaignNotFound", e.FormNotFound = "FormNotFound", e.DraftSelectionRequired = "DraftSelectionRequired", e.AlreadyConverted = "AlreadyConverted", e.CampaignIneligible = "CampaignIneligible", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Ready = "Ready", e.Missing = "Missing", e.NeedsReview = "NeedsReview", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Exclusive = "Exclusive", e.Open = "Open", e.Sole = "Sole", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Information = "Information", e.Action = "Action", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.And = "And", e.Or = "Or", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), ne = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), re = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ie = /* @__PURE__ */ function(e) {
	return e.Offline = "Offline", e.Live = "Live", e;
}({}), ae = /* @__PURE__ */ function(e) {
	return e.None = "None", e.CompanyManaged = "CompanyManaged", e.SelfManaged = "SelfManaged", e.NonFunctioning = "NonFunctioning", e;
}({}), oe = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), se = /* @__PURE__ */ function(e) {
	return e.Restore = "Restore", e.RevertToCurrent = "RevertToCurrent", e.MarkAsUnderContract = "MarkAsUnderContract", e.MarkAsSold = "MarkAsSold", e.Archive = "Archive", e.Withdraw = "Withdraw", e;
}({}), ce = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Archived = "Archived", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.SalesAdviceDraft = "Sales Advice Draft", e.SubmissionIncomplete = "Submission Incomplete", e.BuyerSigning = "Buyer Signing", e.VendorSigning = "Vendor Signing", e.Signing = "Signing", e.PendingSolicitorExchange = "Pending Solicitor Exchange", e.PendingAgentExchange = "Pending Agent Exchange", e.ContractRequested = "Contract Requested", e.PendingCompliance = "Pending Compliance", e.Accepted = "Accepted", e.Conditional = "Conditional", e.Unconditional = "Unconditional", e.Settled = "Settled", e.Terminated = "Terminated", e.Withdrawn = "Withdrawn", e.SignedByBuyer = "Signed by Buyer", e.SignedByAllParties = "Signed by all Parties", e.BackUp = "Back Up", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.PendingCompliance = "PendingCompliance", e.Current = "Current", e.UnderContract = "UnderContract", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.Flat = "Flat", e.Tiered = "Tiered", e.VendorChoice = "VendorChoice", e.Other = "Other", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), H = /* @__PURE__ */ function(e) {
	return e.Search = "Search", e.Manual = "Manual", e.AttachAsFile = "AttachAsFile", e.NotAvailable = "NotAvailable", e;
}({}), U = /* @__PURE__ */ function(e) {
	return e.OnDate = "OnDate", e.NdaysFromDate = "NdaysFromDate", e.OnSpecificDate = "OnSpecificDate", e.UponSatisfactionOfSpecialCondition = "UponSatisfactionOfSpecialCondition", e.AdditionalReason = "AdditionalReason", e.NotApplicable = "NotApplicable", e.NotSubjectToFinance = "NotSubjectToFinance", e.Other = "Other", e.AsPerContract = "AsPerContract", e.BuildingAndPestBeingSatisfied = "BuildingAndPestBeingSatisfied", e.FinanceBeingSatisfied = "FinanceBeingSatisfied", e.OnCoolingOffDate = "OnCoolingOffDate", e;
}({}), W = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Finance = "Finance", e;
}({}), G = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Email = "Email", e.Phone = "Phone", e.Currency = "Currency", e.TextArea = "TextArea", e;
}({}), le = /* @__PURE__ */ function(e) {
	return e.RevertToAccepted = "RevertToAccepted", e.RevertToUnconditional = "RevertToUnconditional", e.MarkAsAwaitingExchange = "MarkAsAwaitingExchange", e.MarkAsAccepted = "MarkAsAccepted", e.MarkAsUnconditional = "MarkAsUnconditional", e.MarkSettled = "MarkSettled", e.Terminated = "Terminated", e.Cancelled = "Cancelled", e;
}({}), ue = /* @__PURE__ */ function(e) {
	return e.SalesAdvice = "SalesAdvice", e.ContractExchange = "ContractExchange", e;
}({}), de = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), fe = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e;
}({}), pe = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e;
}({}), me = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.AwaitingInitialDeposit = "AwaitingInitialDeposit", e.AwaitingAdditionalDeposit = "AwaitingAdditionalDeposit", e.FullyReleased = "FullyReleased", e.Ineligible = "Ineligible", e;
}({}), he = /* @__PURE__ */ function(e) {
	return e.PendingSolicitorExchange = "PendingSolicitorExchange", e.PendingAgentExchange = "PendingAgentExchange", e.PendingCompliance = "PendingCompliance", e.Accepted = "Accepted", e.Unconditional = "Unconditional", e.Settled = "Settled", e.Terminated = "Terminated", e;
}({}), ge = /* @__PURE__ */ function(e) {
	return e.HouseAndLand = "HouseAndLand", e.CommunityTitles = "CommunityTitles", e.NewContract2025 = "NewContract2025", e;
}({}), _e = /* @__PURE__ */ function(e) {
	return e.IncludeShorteningOfCoolingOff = "IncludeShorteningOfCoolingOff", e.IncludeWaiverOfCoolingOff = "IncludeWaiverOfCoolingOff", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.FiveDays = "FiveDays", e.TenDays = "TenDays", e.NDays = "NDays", e.NoCoolingOff = "NoCoolingOff", e;
}({}), K = /* @__PURE__ */ function(e) {
	return e.Aruba = "Aruba", e.Afghanistan = "Afghanistan", e.Angola = "Angola", e.Anguilla = "Anguilla", e.AlandIslands = "AlandIslands", e.Albania = "Albania", e.Andorra = "Andorra", e.UnitedArabEmirates = "UnitedArabEmirates", e.Argentina = "Argentina", e.Armenia = "Armenia", e.AmericanSamoa = "AmericanSamoa", e.Antarctica = "Antarctica", e.FrenchSouthernTerritories = "FrenchSouthernTerritories", e.AntiguaAndBarbuda = "AntiguaAndBarbuda", e.Australia = "Australia", e.Austria = "Austria", e.Azerbaijan = "Azerbaijan", e.Burundi = "Burundi", e.Belgium = "Belgium", e.Benin = "Benin", e.BonaireSintEustatiusAndSaba = "BonaireSintEustatiusAndSaba", e.BurkinaFaso = "BurkinaFaso", e.Bangladesh = "Bangladesh", e.Bulgaria = "Bulgaria", e.Bahrain = "Bahrain", e.Bahamas = "Bahamas", e.BosniaAndHerzegovina = "BosniaAndHerzegovina", e.SaintBarthelemy = "SaintBarthelemy", e.Belarus = "Belarus", e.Belize = "Belize", e.Bermuda = "Bermuda", e.Bolivia = "Bolivia", e.Brazil = "Brazil", e.Barbados = "Barbados", e.Brunei = "Brunei", e.Bhutan = "Bhutan", e.BouvetIsland = "BouvetIsland", e.Botswana = "Botswana", e.CentralAfricanRepublic = "CentralAfricanRepublic", e.Canada = "Canada", e.CocosKeelingIslands = "CocosKeelingIslands", e.Switzerland = "Switzerland", e.Chile = "Chile", e.China = "China", e.IvoryCoast = "IvoryCoast", e.Cameroon = "Cameroon", e.DemocraticRepublicOfTheCongo = "DemocraticRepublicOfTheCongo", e.RepublicOfTheCongo = "RepublicOfTheCongo", e.CookIslands = "CookIslands", e.Colombia = "Colombia", e.Comoros = "Comoros", e.CapeVerde = "CapeVerde", e.CostaRica = "CostaRica", e.Cuba = "Cuba", e.Curacao = "Curacao", e.ChristmasIsland = "ChristmasIsland", e.CaymanIslands = "CaymanIslands", e.Cyprus = "Cyprus", e.CzechRepublic = "CzechRepublic", e.Germany = "Germany", e.Djibouti = "Djibouti", e.Dominica = "Dominica", e.Denmark = "Denmark", e.DominicanRepublic = "DominicanRepublic", e.Algeria = "Algeria", e.Ecuador = "Ecuador", e.Egypt = "Egypt", e.Eritrea = "Eritrea", e.WesternSahara = "WesternSahara", e.Spain = "Spain", e.Estonia = "Estonia", e.Ethiopia = "Ethiopia", e.Finland = "Finland", e.Fiji = "Fiji", e.FalklandIslands = "FalklandIslands", e.France = "France", e.FaroeIslands = "FaroeIslands", e.Micronesia = "Micronesia", e.Gabon = "Gabon", e.UnitedKingdom = "UnitedKingdom", e.Georgia = "Georgia", e.Guernsey = "Guernsey", e.Ghana = "Ghana", e.Gibraltar = "Gibraltar", e.Guinea = "Guinea", e.Guadeloupe = "Guadeloupe", e.Gambia = "Gambia", e.GuineaBissau = "GuineaBissau", e.EquatorialGuinea = "EquatorialGuinea", e.Greece = "Greece", e.Grenada = "Grenada", e.Greenland = "Greenland", e.Guatemala = "Guatemala", e.FrenchGuiana = "FrenchGuiana", e.Guam = "Guam", e.Guyana = "Guyana", e.HongKong = "HongKong", e.HeardIslandAndMcDonaldIslands = "HeardIslandAndMcDonaldIslands", e.Honduras = "Honduras", e.Croatia = "Croatia", e.Haiti = "Haiti", e.Hungary = "Hungary", e.Indonesia = "Indonesia", e.IsleOfMan = "IsleOfMan", e.India = "India", e.BritishIndianOceanTerritory = "BritishIndianOceanTerritory", e.Ireland = "Ireland", e.Iran = "Iran", e.Iraq = "Iraq", e.Iceland = "Iceland", e.Israel = "Israel", e.Italy = "Italy", e.Jamaica = "Jamaica", e.Jersey = "Jersey", e.Jordan = "Jordan", e.Japan = "Japan", e.Kazakhstan = "Kazakhstan", e.Kenya = "Kenya", e.Kyrgyzstan = "Kyrgyzstan", e.Cambodia = "Cambodia", e.Kiribati = "Kiribati", e.SaintKittsAndNevis = "SaintKittsAndNevis", e.SouthKorea = "SouthKorea", e.Kuwait = "Kuwait", e.Laos = "Laos", e.Lebanon = "Lebanon", e.Liberia = "Liberia", e.Libya = "Libya", e.SaintLucia = "SaintLucia", e.Liechtenstein = "Liechtenstein", e.SriLanka = "SriLanka", e.Lesotho = "Lesotho", e.Lithuania = "Lithuania", e.Luxembourg = "Luxembourg", e.Latvia = "Latvia", e.Macau = "Macau", e.SaintMartin = "SaintMartin", e.Morocco = "Morocco", e.Monaco = "Monaco", e.Moldova = "Moldova", e.Madagascar = "Madagascar", e.Maldives = "Maldives", e.Mexico = "Mexico", e.MarshallIslands = "MarshallIslands", e.NorthMacedonia = "NorthMacedonia", e.Mali = "Mali", e.Malta = "Malta", e.Myanmar = "Myanmar", e.Montenegro = "Montenegro", e.Mongolia = "Mongolia", e.NorthernMarianaIslands = "NorthernMarianaIslands", e.Mozambique = "Mozambique", e.Mauritania = "Mauritania", e.Montserrat = "Montserrat", e.Martinique = "Martinique", e.Mauritius = "Mauritius", e.Malawi = "Malawi", e.Malaysia = "Malaysia", e.Mayotte = "Mayotte", e.Namibia = "Namibia", e.NewCaledonia = "NewCaledonia", e.Niger = "Niger", e.NorfolkIsland = "NorfolkIsland", e.Nigeria = "Nigeria", e.Nicaragua = "Nicaragua", e.Niue = "Niue", e.Netherlands = "Netherlands", e.Norway = "Norway", e.Nepal = "Nepal", e.Nauru = "Nauru", e.NewZealand = "NewZealand", e.Oman = "Oman", e.Pakistan = "Pakistan", e.Panama = "Panama", e.Pitcairn = "Pitcairn", e.Peru = "Peru", e.Philippines = "Philippines", e.Palau = "Palau", e.PapuaNewGuinea = "PapuaNewGuinea", e.Poland = "Poland", e.PuertoRico = "PuertoRico", e.NorthKorea = "NorthKorea", e.Portugal = "Portugal", e.Paraguay = "Paraguay", e.Palestine = "Palestine", e.FrenchPolynesia = "FrenchPolynesia", e.Qatar = "Qatar", e.Reunion = "Reunion", e.Romania = "Romania", e.Russia = "Russia", e.Rwanda = "Rwanda", e.SaudiArabia = "SaudiArabia", e.Sudan = "Sudan", e.Senegal = "Senegal", e.Singapore = "Singapore", e.SouthGeorgiaAndTheSouthSandwichIslands = "SouthGeorgiaAndTheSouthSandwichIslands", e.SaintHelena = "SaintHelena", e.SvalbardAndJanMayen = "SvalbardAndJanMayen", e.SolomonIslands = "SolomonIslands", e.SierraLeone = "SierraLeone", e.ElSalvador = "ElSalvador", e.SanMarino = "SanMarino", e.Somalia = "Somalia", e.SaintPierreAndMiquelon = "SaintPierreAndMiquelon", e.Serbia = "Serbia", e.SouthSudan = "SouthSudan", e.SaoTomeAndPrincipe = "SaoTomeAndPrincipe", e.Suriname = "Suriname", e.Slovakia = "Slovakia", e.Slovenia = "Slovenia", e.Sweden = "Sweden", e.Swaziland = "Swaziland", e.SintMaarten = "SintMaarten", e.Seychelles = "Seychelles", e.Syria = "Syria", e.TurksAndCaicosIslands = "TurksAndCaicosIslands", e.Chad = "Chad", e.Togo = "Togo", e.Thailand = "Thailand", e.Tajikistan = "Tajikistan", e.Tokelau = "Tokelau", e.Turkmenistan = "Turkmenistan", e.EastTimor = "EastTimor", e.Tonga = "Tonga", e.TrinidadAndTobago = "TrinidadAndTobago", e.Tunisia = "Tunisia", e.Turkey = "Turkey", e.Tuvalu = "Tuvalu", e.Taiwan = "Taiwan", e.Tanzania = "Tanzania", e.Uganda = "Uganda", e.Ukraine = "Ukraine", e.UnitedStatesMinorOutlyingIslands = "UnitedStatesMinorOutlyingIslands", e.Uruguay = "Uruguay", e.UnitedStates = "UnitedStates", e.Uzbekistan = "Uzbekistan", e.VaticanCity = "VaticanCity", e.SaintVincentAndTheGrenadines = "SaintVincentAndTheGrenadines", e.Venezuela = "Venezuela", e.BritishVirginIslands = "BritishVirginIslands", e.USVirginIslands = "USVirginIslands", e.Vietnam = "Vietnam", e.Vanuatu = "Vanuatu", e.WallisAndFutuna = "WallisAndFutuna", e.Samoa = "Samoa", e.Yemen = "Yemen", e.SouthAfrica = "SouthAfrica", e.Zambia = "Zambia", e.Zimbabwe = "Zimbabwe", e;
}({}), ye = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), be = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.BusinessDays = "BusinessDays", e;
}({}), xe = /* @__PURE__ */ function(e) {
	return e.On = "On", e.NDaysFrom = "NDaysFrom", e;
}({}), Se = /* @__PURE__ */ function(e) {
	return e.PartialDepositPaidUpfront = "PartialDepositPaidUpfront", e.FullDepositPaidUpfront = "FullDepositPaidUpfront", e;
}({}), Ce = /* @__PURE__ */ function(e) {
	return e.Initial = "Initial", e.Balance = "Balance", e;
}({}), we = /* @__PURE__ */ function(e) {
	return e.DocuSign = "DocuSign", e.UploadedManually = "UploadedManually", e;
}({}), Te = /* @__PURE__ */ function(e) {
	return e.None = "None", e.BlankPrepared = "BlankPrepared", e.ContractSubmitted = "ContractSubmitted", e;
}({}), Ee = /* @__PURE__ */ function(e) {
	return e.None = "None", e.Finance = "Finance", e.BuildingAndPest = "BuildingAndPest", e.BodyCorporate = "BodyCorporate", e.CoolingOff = "CoolingOff", e.SeveralSpecialConditions = "SeveralSpecialConditions", e;
}({}), De = /* @__PURE__ */ function(e) {
	return e.AgentPortal = "AgentPortal", e.UploadedManually = "UploadedManually", e;
}({}), Oe = /* @__PURE__ */ function(e) {
	return e.NewContract = "NewContract", e.Accepted = "Accepted", e.Unconditional = "Unconditional", e;
}({}), ke = /* @__PURE__ */ function(e) {
	return e.RPDataSearch = "RPDataSearch", e.ManualAddress = "ManualAddress", e;
}({}), Ae = /* @__PURE__ */ function(e) {
	return e.Standard = "Standard", e.ExceedsTenPercent = "ExceedsTenPercent", e.EarlyRelease = "EarlyRelease", e;
}({}), je = /* @__PURE__ */ function(e) {
	return e.OffMarket = "OffMarket", e.LaunchScheduled = "LaunchScheduled", e;
}({}), Me = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Ne = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), Pe = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Fe = /* @__PURE__ */ function(e) {
	return e.FullEdit = "FullEdit", e.PartialEdit = "PartialEdit", e.ReadOnly = "ReadOnly", e;
}({}), Ie = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), Le = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), Re = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), ze = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Be = /* @__PURE__ */ function(e) {
	return e.AdditionalDocumentations = "AdditionalDocumentations", e.AddressSearch = "AddressSearch", e.BuyersAgentSearch = "BuyersAgentSearch", e.AgreementDetails = "AgreementDetails", e.BuildingAndPest = "BuildingAndPest", e.VendorBuyerDetails = "VendorBuyerDetails", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.ContractDeposit = "ContractDeposit", e.DepositPayable = "DepositPayable", e.Dropdown = "Dropdown", e.Date = "Date", e.DateTime = "DateTime", e.TextInput = "TextInput", e.Radio = "Radio", e.InfoLabel = "InfoLabel", e.PropertySearch = "PropertySearch", e.SolicitorSearch = "SolicitorSearch", e.ListingAgentSelector = "ListingAgentSelector", e.Commission = "Commission", e.PersonName = "PersonName", e.Checkbox = "Checkbox", e.MarketingPackage = "MarketingPackage", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.ReviewAndSign = "ReviewAndSign", e.AlternateAddressSearch = "AlternateAddressSearch", e.FileUpload = "FileUpload", e.TenantedProperty = "TenantedProperty", e.TypedDocumentUpload = "TypedDocumentUpload", e.POADocumentUpload = "POADocumentUpload", e.TextArea = "TextArea", e.SaleDetails = "SaleDetails", e.LaunchDetails = "LaunchDetails", e.SpecialConditions = "SpecialConditions", e.YesNoQuestion = "YesNoQuestion", e.SettlementDate = "SettlementDate", e.SendForDocuSigning = "SendForDocuSigning", e.SignboardRemoval = "SignboardRemoval", e.MarketingContributions = "MarketingContributions", e.DisplayPrice = "DisplayPrice", e.PriceSpecification = "PriceSpecification", e.Currency = "Currency", e.SubjectToFinance = "SubjectToFinance", e.AdjustmentToCommission = "AdjustmentToCommission", e.ExternalConjunction = "ExternalConjunction", e.PropertyType = "PropertyType", e.VendorDetailsDisplay = "VendorDetailsDisplay", e.ConditionalTextInput = "ConditionalTextInput", e.SecondaryAgentCommissionSplit = "SecondaryAgentCommissionSplit", e.TenancyDetails = "TenancyDetails", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.LegalDescription = "LegalDescription", e.PropertyAttributes = "PropertyAttributes", e.ChattelsIncluded = "ChattelsIncluded", e.RuralParticulars = "RuralParticulars", e.PriceOpinion = "PriceOpinion", e.EditablePdfUpload = "EditablePdfUpload", e.Deposit = "Deposit", e.CoolingOffPeriod = "CoolingOffPeriod", e.Image = "Image", e.Alerts = "Alerts", e.MarketingConfirmation = "MarketingConfirmation", e.MarketingLaunchDetails = "MarketingLaunchDetails", e.SellersDisclosurePreparedBy = "SellersDisclosurePreparedBy", e.BodyCorporate = "BodyCorporate", e.SellersDisclosureUpload = "SellersDisclosureUpload", e.CommunityTitlesScheme = "CommunityTitlesScheme", e.BodyCorporateRecords = "BodyCorporateRecords", e.SurveyPlanUpload = "SurveyPlanUpload", e.IdentityVerificationExports = "IdentityVerificationExports", e;
}({}), Ve = /* @__PURE__ */ function(e) {
	return e.Employee = "Employee", e.SelfEmployed = "SelfEmployed", e.Unemployed = "Unemployed", e.Retired = "Retired", e;
}({}), He = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), Ue = /* @__PURE__ */ function(e) {
	return e.Manual = "Manual", e.DocuSign = "DocuSign", e.Email = "Email", e;
}({}), We = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), Ge = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), Ke = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), qe = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), Je = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e.ListingProposal = "ListingProposal", e;
}({}), Ye = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Staff = "Staff", e;
}({}), Xe = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Ze = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e.ListingProposal = "ListingProposal", e;
}({}), Qe = /* @__PURE__ */ function(e) {
	return e.None = "None", e.ForwardAndBack = "ForwardAndBack", e.BackAndReview = "BackAndReview", e.BackAndSubmit = "BackAndSubmit", e.Forward = "Forward", e;
}({}), $e = /* @__PURE__ */ function(e) {
	return e.Send = "Send", e.GeneratePdf = "GeneratePdf", e;
}({}), et = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), tt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e.ListingProposal = "ListingProposal", e;
}({}), nt = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), rt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e.ListingProposal = "ListingProposal", e;
}({}), it = /* @__PURE__ */ function(e) {
	return e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e;
}({}), at = /* @__PURE__ */ function(e) {
	return e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e;
}({}), ot = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), st = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), ct = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), lt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e.ListingProposal = "ListingProposal", e;
}({}), ut = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e[e._7 = 7] = "_7", e;
}({}), dt = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), ft = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), pt = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), mt = /* @__PURE__ */ function(e) {
	return e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e.LaunchDateNotSet = "LaunchDateNotSet", e.OffMarket = "OffMarket", e;
}({}), ht = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), gt = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), _t = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), vt = /* @__PURE__ */ function(e) {
	return e.Paid = "Paid", e.AwaitingFunds = "AwaitingFunds", e;
}({}), yt = /* @__PURE__ */ function(e) {
	return e.Waived = "Waived", e.Exempt = "Exempt", e;
}({}), bt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), xt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), St = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Ct = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), wt = /* @__PURE__ */ function(e) {
	return e.EQ = "EQ", e.NEQ = "NEQ", e.LT = "LT", e.GT = "GT", e.LTEQ = "LTEQ", e.GTEQ = "GTEQ", e;
}({}), Tt = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), Et = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Dt = /* @__PURE__ */ function(e) {
	return e.JointTenants = "JointTenants", e.TenantsInCommon = "TenantsInCommon", e.Trustee = "Trustee", e.SoleProprietor = "SoleProprietor", e;
}({}), Ot = /* @__PURE__ */ function(e) {
	return e.Complete = "Complete", e.Future = "Future", e.FutureDisabled = "FutureDisabled", e.Invalid = "Invalid", e;
}({}), kt = /* @__PURE__ */ function(e) {
	return e.Australia = "Australia", e.NewSouthWales = "NewSouthWales", e.Other = "Other", e.Queensland = "Queensland", e.Victoria = "Victoria", e.NorthernTerritory = "NorthernTerritory", e.SouthAustralia = "SouthAustralia", e.WesternAustralia = "WesternAustralia", e.AustralianCapitalTerritory = "AustralianCapitalTerritory", e.Tasmania = "Tasmania", e;
}({}), At = /* @__PURE__ */ function(e) {
	return e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.NoPoolCertificate = "NoPoolCertificate", e;
}({}), jt = /* @__PURE__ */ function(e) {
	return e.NoPool = "NoPool", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.Form36 = "Form36", e;
}({}), Mt = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Nt = /* @__PURE__ */ function(e) {
	return e.Pending = "Pending", e.Failed = "Failed", e.Interrupted = "Interrupted", e;
}({}), Pt = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Ft = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), It = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Lt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Rt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), zt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Bt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Vt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Ht = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Ut = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Wt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Gt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Kt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), qt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Jt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Yt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Xt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Zt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Qt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), $t = /* @__PURE__ */ function(e) {
	return e.Downsizing = "Downsizing", e.Upsizing = "Upsizing", e.Relocating = "Relocating", e.Other = "Other", e;
}({}), en = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), tn = /* @__PURE__ */ function(e) {
	return e.Weekly = "Weekly", e.Fortnightly = "Fortnightly", e.Monthly = "Monthly", e;
}({}), nn = /* @__PURE__ */ function(e) {
	return e.Campaign = "Campaign", e.Contract = "Contract", e;
}({}), rn = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), an = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), on = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), sn = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), cn = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), ln = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), un = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), dn = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), fn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), pn = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), mn = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e.ListingProposal = "ListingProposal", e;
}({}), hn = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), gn = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), _n = /* @__PURE__ */ function(e) {
	return e.SettlementDateSet = "SettlementDateSet", e.NoDateSet = "NoDateSet", e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e;
}({}), vn = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), yn = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), bn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), xn = /* @__PURE__ */ function(e) {
	return e.Other = "Other", e.ToBeAdvised = "ToBeAdvised", e;
}({}), Sn = /* @__PURE__ */ function(e) {
	return e.LaunchDateAsc = "LaunchDateAsc", e.LaunchDateDesc = "LaunchDateDesc", e;
}({}), Cn = /* @__PURE__ */ function(e) {
	return e.SettlementDateAsc = "SettlementDateAsc", e.SettlementDateDesc = "SettlementDateDesc", e;
}({}), wn = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), Tn = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), En = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Dn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.VendorSolicitor = "VendorSolicitor", e.Other = "Other", e;
}({}), On = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.VendorSolicitor = "VendorSolicitor", e.Other = "Other", e;
}({}), kn = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), An = /* @__PURE__ */ function(e) {
	return e.Together = "Together", e.Separately = "Separately", e;
}({}), jn = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), Mn = /* @__PURE__ */ function(e) {
	return e.Pexa = "Pexa", e.InPerson = "InPerson", e;
}({}), Nn = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Pn = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e.DoNotUpdate = "DoNotUpdate", e;
}({}), Fn = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), In = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), Ln = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), Rn = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), zn = /* @__PURE__ */ function(e) {
	return e.Pexa = "Pexa", e.InPerson = "InPerson", e;
}({}), Bn = /* @__PURE__ */ function(e) {
	return e.CoolingOffPeriod = "CoolingOffPeriod", e.FailedFinance = "FailedFinance", e.FailedBuildingAndPest = "FailedBuildingAndPest", e.SpecialConditions = "SpecialConditions", e;
}({}), Vn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.NoDepositReceived = "NoDepositReceived", e;
}({}), Hn = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), Un = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Wn = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e.DoNotUpdate = "DoNotUpdate", e;
}({}), Gn = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), Kn = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), qn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), Jn = /* @__PURE__ */ function(e) {
	return e.Act = "Act", e.Nsw = "Nsw", e.Nt = "Nt", e.Qld = "Qld", e.Sa = "Sa", e.Tas = "Tas", e.Wa = "Wa", e.Vic = "Vic", e;
}({}), Yn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Xn = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), Zn = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), Qn = /* @__PURE__ */ function(e) {
	return e.NotTenanted = "NotTenanted", e.TenantedAgencyManaged = "TenantedAgencyManaged", e.TenantedSelfManaged = "TenantedSelfManaged", e.Unknown = "Unknown", e.TenantedAgencyManagedHolidayRental = "TenantedAgencyManagedHolidayRental", e;
}({}), $n = /* @__PURE__ */ function(e) {
	return e.SingleRate = "SingleRate", e.MultiRate = "MultiRate", e;
}({}), er = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.Weeks = "Weeks", e.Months = "Months", e.Years = "Years", e;
}({}), tr = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), nr = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), rr = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), ir = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Docusign = "Docusign", e;
}({}), ar = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), or = /* @__PURE__ */ function(e) {
	return e.Dollar = "Dollar", e.Percentage = "Percentage", e;
}({}), sr = /* @__PURE__ */ function(e) {
	return e.Outstanding = "Outstanding", e.Complete = "Complete", e.Na = "Na", e;
}({}), cr = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), lr = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), ur = /* @__PURE__ */ function(e) {
	return e.Together = "Together", e.Separately = "Separately", e;
}({}), dr = /* @__PURE__ */ function(e) {
	return e.InPerson = "InPerson", e.Biometric = "Biometric", e.NoPhotoId = "NoPhotoId", e;
}({}), fr = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), pr = [
	{
		country: K.Aruba,
		name: "Aruba",
		isoCode2: "AW",
		isoCode3: "ABW",
		aliases: []
	},
	{
		country: K.Afghanistan,
		name: "Afghanistan",
		isoCode2: "AF",
		isoCode3: "AFG",
		aliases: []
	},
	{
		country: K.Angola,
		name: "Angola",
		isoCode2: "AO",
		isoCode3: "AGO",
		aliases: []
	},
	{
		country: K.Anguilla,
		name: "Anguilla",
		isoCode2: "AI",
		isoCode3: "AIA",
		aliases: []
	},
	{
		country: K.AlandIslands,
		name: "Åland Islands",
		isoCode2: "AX",
		isoCode3: "ALA",
		aliases: []
	},
	{
		country: K.Albania,
		name: "Albania",
		isoCode2: "AL",
		isoCode3: "ALB",
		aliases: []
	},
	{
		country: K.Andorra,
		name: "Andorra",
		isoCode2: "AD",
		isoCode3: "AND",
		aliases: []
	},
	{
		country: K.UnitedArabEmirates,
		name: "United Arab Emirates",
		isoCode2: "AE",
		isoCode3: "ARE",
		aliases: []
	},
	{
		country: K.Argentina,
		name: "Argentina",
		isoCode2: "AR",
		isoCode3: "ARG",
		aliases: []
	},
	{
		country: K.Armenia,
		name: "Armenia",
		isoCode2: "AM",
		isoCode3: "ARM",
		aliases: []
	},
	{
		country: K.AmericanSamoa,
		name: "American Samoa",
		isoCode2: "AS",
		isoCode3: "ASM",
		aliases: []
	},
	{
		country: K.Antarctica,
		name: "Antarctica",
		isoCode2: "AQ",
		isoCode3: "ATA",
		aliases: []
	},
	{
		country: K.FrenchSouthernTerritories,
		name: "French Southern Territories",
		isoCode2: "TF",
		isoCode3: "ATF",
		aliases: []
	},
	{
		country: K.AntiguaAndBarbuda,
		name: "Antigua and Barbuda",
		isoCode2: "AG",
		isoCode3: "ATG",
		aliases: []
	},
	{
		country: K.Australia,
		name: "Australia",
		isoCode2: "AU",
		isoCode3: "AUS",
		aliases: []
	},
	{
		country: K.Austria,
		name: "Austria",
		isoCode2: "AT",
		isoCode3: "AUT",
		aliases: []
	},
	{
		country: K.Azerbaijan,
		name: "Azerbaijan",
		isoCode2: "AZ",
		isoCode3: "AZE",
		aliases: []
	},
	{
		country: K.Burundi,
		name: "Burundi",
		isoCode2: "BI",
		isoCode3: "BDI",
		aliases: []
	},
	{
		country: K.Belgium,
		name: "Belgium",
		isoCode2: "BE",
		isoCode3: "BEL",
		aliases: []
	},
	{
		country: K.Benin,
		name: "Benin",
		isoCode2: "BJ",
		isoCode3: "BEN",
		aliases: []
	},
	{
		country: K.BonaireSintEustatiusAndSaba,
		name: "Bonaire, Sint Eustatius and Saba",
		isoCode2: "BQ",
		isoCode3: "BES",
		aliases: []
	},
	{
		country: K.BurkinaFaso,
		name: "Burkina Faso",
		isoCode2: "BF",
		isoCode3: "BFA",
		aliases: []
	},
	{
		country: K.Bangladesh,
		name: "Bangladesh",
		isoCode2: "BD",
		isoCode3: "BGD",
		aliases: []
	},
	{
		country: K.Bulgaria,
		name: "Bulgaria",
		isoCode2: "BG",
		isoCode3: "BGR",
		aliases: []
	},
	{
		country: K.Bahrain,
		name: "Bahrain",
		isoCode2: "BH",
		isoCode3: "BHR",
		aliases: []
	},
	{
		country: K.Bahamas,
		name: "Bahamas",
		isoCode2: "BS",
		isoCode3: "BHS",
		aliases: []
	},
	{
		country: K.BosniaAndHerzegovina,
		name: "Bosnia and Herzegovina",
		isoCode2: "BA",
		isoCode3: "BIH",
		aliases: []
	},
	{
		country: K.SaintBarthelemy,
		name: "Saint Barthélemy",
		isoCode2: "BL",
		isoCode3: "BLM",
		aliases: []
	},
	{
		country: K.Belarus,
		name: "Belarus",
		isoCode2: "BY",
		isoCode3: "BLR",
		aliases: []
	},
	{
		country: K.Belize,
		name: "Belize",
		isoCode2: "BZ",
		isoCode3: "BLZ",
		aliases: []
	},
	{
		country: K.Bermuda,
		name: "Bermuda",
		isoCode2: "BM",
		isoCode3: "BMU",
		aliases: []
	},
	{
		country: K.Bolivia,
		name: "Bolivia",
		isoCode2: "BO",
		isoCode3: "BOL",
		aliases: ["Bolivia, Plurinational State of"]
	},
	{
		country: K.Brazil,
		name: "Brazil",
		isoCode2: "BR",
		isoCode3: "BRA",
		aliases: []
	},
	{
		country: K.Barbados,
		name: "Barbados",
		isoCode2: "BB",
		isoCode3: "BRB",
		aliases: []
	},
	{
		country: K.Brunei,
		name: "Brunei",
		isoCode2: "BN",
		isoCode3: "BRN",
		aliases: ["Brunei Darussalam"]
	},
	{
		country: K.Bhutan,
		name: "Bhutan",
		isoCode2: "BT",
		isoCode3: "BTN",
		aliases: []
	},
	{
		country: K.BouvetIsland,
		name: "Bouvet Island",
		isoCode2: "BV",
		isoCode3: "BVT",
		aliases: []
	},
	{
		country: K.Botswana,
		name: "Botswana",
		isoCode2: "BW",
		isoCode3: "BWA",
		aliases: []
	},
	{
		country: K.CentralAfricanRepublic,
		name: "Central African Republic",
		isoCode2: "CF",
		isoCode3: "CAF",
		aliases: []
	},
	{
		country: K.Canada,
		name: "Canada",
		isoCode2: "CA",
		isoCode3: "CAN",
		aliases: []
	},
	{
		country: K.CocosKeelingIslands,
		name: "Cocos (Keeling) Islands",
		isoCode2: "CC",
		isoCode3: "CCK",
		aliases: []
	},
	{
		country: K.Switzerland,
		name: "Switzerland",
		isoCode2: "CH",
		isoCode3: "CHE",
		aliases: []
	},
	{
		country: K.Chile,
		name: "Chile",
		isoCode2: "CL",
		isoCode3: "CHL",
		aliases: []
	},
	{
		country: K.China,
		name: "China",
		isoCode2: "CN",
		isoCode3: "CHN",
		aliases: []
	},
	{
		country: K.IvoryCoast,
		name: "Ivory Coast",
		isoCode2: "CI",
		isoCode3: "CIV",
		aliases: ["Côte d'Ivoire"]
	},
	{
		country: K.Cameroon,
		name: "Cameroon",
		isoCode2: "CM",
		isoCode3: "CMR",
		aliases: []
	},
	{
		country: K.DemocraticRepublicOfTheCongo,
		name: "Democratic Republic of the Congo",
		isoCode2: "CD",
		isoCode3: "COD",
		aliases: ["Congo, The Democratic Republic of the"]
	},
	{
		country: K.RepublicOfTheCongo,
		name: "Republic of the Congo",
		isoCode2: "CG",
		isoCode3: "COG",
		aliases: ["Congo"]
	},
	{
		country: K.CookIslands,
		name: "Cook Islands",
		isoCode2: "CK",
		isoCode3: "COK",
		aliases: []
	},
	{
		country: K.Colombia,
		name: "Colombia",
		isoCode2: "CO",
		isoCode3: "COL",
		aliases: []
	},
	{
		country: K.Comoros,
		name: "Comoros",
		isoCode2: "KM",
		isoCode3: "COM",
		aliases: []
	},
	{
		country: K.CapeVerde,
		name: "Cape Verde",
		isoCode2: "CV",
		isoCode3: "CPV",
		aliases: ["Cabo Verde"]
	},
	{
		country: K.CostaRica,
		name: "Costa Rica",
		isoCode2: "CR",
		isoCode3: "CRI",
		aliases: []
	},
	{
		country: K.Cuba,
		name: "Cuba",
		isoCode2: "CU",
		isoCode3: "CUB",
		aliases: []
	},
	{
		country: K.Curacao,
		name: "Curaçao",
		isoCode2: "CW",
		isoCode3: "CUW",
		aliases: []
	},
	{
		country: K.ChristmasIsland,
		name: "Christmas Island",
		isoCode2: "CX",
		isoCode3: "CXR",
		aliases: []
	},
	{
		country: K.CaymanIslands,
		name: "Cayman Islands",
		isoCode2: "KY",
		isoCode3: "CYM",
		aliases: []
	},
	{
		country: K.Cyprus,
		name: "Cyprus",
		isoCode2: "CY",
		isoCode3: "CYP",
		aliases: []
	},
	{
		country: K.CzechRepublic,
		name: "Czech Republic",
		isoCode2: "CZ",
		isoCode3: "CZE",
		aliases: ["Czechia"]
	},
	{
		country: K.Germany,
		name: "Germany",
		isoCode2: "DE",
		isoCode3: "DEU",
		aliases: []
	},
	{
		country: K.Djibouti,
		name: "Djibouti",
		isoCode2: "DJ",
		isoCode3: "DJI",
		aliases: []
	},
	{
		country: K.Dominica,
		name: "Dominica",
		isoCode2: "DM",
		isoCode3: "DMA",
		aliases: []
	},
	{
		country: K.Denmark,
		name: "Denmark",
		isoCode2: "DK",
		isoCode3: "DNK",
		aliases: []
	},
	{
		country: K.DominicanRepublic,
		name: "Dominican Republic",
		isoCode2: "DO",
		isoCode3: "DOM",
		aliases: []
	},
	{
		country: K.Algeria,
		name: "Algeria",
		isoCode2: "DZ",
		isoCode3: "DZA",
		aliases: []
	},
	{
		country: K.Ecuador,
		name: "Ecuador",
		isoCode2: "EC",
		isoCode3: "ECU",
		aliases: []
	},
	{
		country: K.Egypt,
		name: "Egypt",
		isoCode2: "EG",
		isoCode3: "EGY",
		aliases: []
	},
	{
		country: K.Eritrea,
		name: "Eritrea",
		isoCode2: "ER",
		isoCode3: "ERI",
		aliases: []
	},
	{
		country: K.WesternSahara,
		name: "Western Sahara",
		isoCode2: "EH",
		isoCode3: "ESH",
		aliases: []
	},
	{
		country: K.Spain,
		name: "Spain",
		isoCode2: "ES",
		isoCode3: "ESP",
		aliases: []
	},
	{
		country: K.Estonia,
		name: "Estonia",
		isoCode2: "EE",
		isoCode3: "EST",
		aliases: []
	},
	{
		country: K.Ethiopia,
		name: "Ethiopia",
		isoCode2: "ET",
		isoCode3: "ETH",
		aliases: []
	},
	{
		country: K.Finland,
		name: "Finland",
		isoCode2: "FI",
		isoCode3: "FIN",
		aliases: []
	},
	{
		country: K.Fiji,
		name: "Fiji",
		isoCode2: "FJ",
		isoCode3: "FJI",
		aliases: []
	},
	{
		country: K.FalklandIslands,
		name: "Falkland Islands",
		isoCode2: "FK",
		isoCode3: "FLK",
		aliases: ["Falkland Islands (Malvinas)"]
	},
	{
		country: K.France,
		name: "France",
		isoCode2: "FR",
		isoCode3: "FRA",
		aliases: []
	},
	{
		country: K.FaroeIslands,
		name: "Faroe Islands",
		isoCode2: "FO",
		isoCode3: "FRO",
		aliases: []
	},
	{
		country: K.Micronesia,
		name: "Micronesia",
		isoCode2: "FM",
		isoCode3: "FSM",
		aliases: ["Micronesia, Federated States of"]
	},
	{
		country: K.Gabon,
		name: "Gabon",
		isoCode2: "GA",
		isoCode3: "GAB",
		aliases: []
	},
	{
		country: K.UnitedKingdom,
		name: "United Kingdom",
		isoCode2: "GB",
		isoCode3: "GBR",
		aliases: ["Great Britain"]
	},
	{
		country: K.Georgia,
		name: "Georgia",
		isoCode2: "GE",
		isoCode3: "GEO",
		aliases: []
	},
	{
		country: K.Guernsey,
		name: "Guernsey",
		isoCode2: "GG",
		isoCode3: "GGY",
		aliases: []
	},
	{
		country: K.Ghana,
		name: "Ghana",
		isoCode2: "GH",
		isoCode3: "GHA",
		aliases: []
	},
	{
		country: K.Gibraltar,
		name: "Gibraltar",
		isoCode2: "GI",
		isoCode3: "GIB",
		aliases: []
	},
	{
		country: K.Guinea,
		name: "Guinea",
		isoCode2: "GN",
		isoCode3: "GIN",
		aliases: []
	},
	{
		country: K.Guadeloupe,
		name: "Guadeloupe",
		isoCode2: "GP",
		isoCode3: "GLP",
		aliases: []
	},
	{
		country: K.Gambia,
		name: "Gambia",
		isoCode2: "GM",
		isoCode3: "GMB",
		aliases: []
	},
	{
		country: K.GuineaBissau,
		name: "Guinea-Bissau",
		isoCode2: "GW",
		isoCode3: "GNB",
		aliases: []
	},
	{
		country: K.EquatorialGuinea,
		name: "Equatorial Guinea",
		isoCode2: "GQ",
		isoCode3: "GNQ",
		aliases: []
	},
	{
		country: K.Greece,
		name: "Greece",
		isoCode2: "GR",
		isoCode3: "GRC",
		aliases: []
	},
	{
		country: K.Grenada,
		name: "Grenada",
		isoCode2: "GD",
		isoCode3: "GRD",
		aliases: []
	},
	{
		country: K.Greenland,
		name: "Greenland",
		isoCode2: "GL",
		isoCode3: "GRL",
		aliases: []
	},
	{
		country: K.Guatemala,
		name: "Guatemala",
		isoCode2: "GT",
		isoCode3: "GTM",
		aliases: []
	},
	{
		country: K.FrenchGuiana,
		name: "French Guiana",
		isoCode2: "GF",
		isoCode3: "GUF",
		aliases: []
	},
	{
		country: K.Guam,
		name: "Guam",
		isoCode2: "GU",
		isoCode3: "GUM",
		aliases: []
	},
	{
		country: K.Guyana,
		name: "Guyana",
		isoCode2: "GY",
		isoCode3: "GUY",
		aliases: []
	},
	{
		country: K.HongKong,
		name: "Hong Kong",
		isoCode2: "HK",
		isoCode3: "HKG",
		aliases: []
	},
	{
		country: K.HeardIslandAndMcDonaldIslands,
		name: "Heard Island and McDonald Islands",
		isoCode2: "HM",
		isoCode3: "HMD",
		aliases: []
	},
	{
		country: K.Honduras,
		name: "Honduras",
		isoCode2: "HN",
		isoCode3: "HND",
		aliases: []
	},
	{
		country: K.Croatia,
		name: "Croatia",
		isoCode2: "HR",
		isoCode3: "HRV",
		aliases: []
	},
	{
		country: K.Haiti,
		name: "Haiti",
		isoCode2: "HT",
		isoCode3: "HTI",
		aliases: []
	},
	{
		country: K.Hungary,
		name: "Hungary",
		isoCode2: "HU",
		isoCode3: "HUN",
		aliases: []
	},
	{
		country: K.Indonesia,
		name: "Indonesia",
		isoCode2: "ID",
		isoCode3: "IDN",
		aliases: []
	},
	{
		country: K.IsleOfMan,
		name: "Isle of Man",
		isoCode2: "IM",
		isoCode3: "IMN",
		aliases: []
	},
	{
		country: K.India,
		name: "India",
		isoCode2: "IN",
		isoCode3: "IND",
		aliases: []
	},
	{
		country: K.BritishIndianOceanTerritory,
		name: "British Indian Ocean Territory",
		isoCode2: "IO",
		isoCode3: "IOT",
		aliases: []
	},
	{
		country: K.Ireland,
		name: "Ireland",
		isoCode2: "IE",
		isoCode3: "IRL",
		aliases: []
	},
	{
		country: K.Iran,
		name: "Iran",
		isoCode2: "IR",
		isoCode3: "IRN",
		aliases: ["Iran, Islamic Republic of"]
	},
	{
		country: K.Iraq,
		name: "Iraq",
		isoCode2: "IQ",
		isoCode3: "IRQ",
		aliases: []
	},
	{
		country: K.Iceland,
		name: "Iceland",
		isoCode2: "IS",
		isoCode3: "ISL",
		aliases: []
	},
	{
		country: K.Israel,
		name: "Israel",
		isoCode2: "IL",
		isoCode3: "ISR",
		aliases: []
	},
	{
		country: K.Italy,
		name: "Italy",
		isoCode2: "IT",
		isoCode3: "ITA",
		aliases: []
	},
	{
		country: K.Jamaica,
		name: "Jamaica",
		isoCode2: "JM",
		isoCode3: "JAM",
		aliases: []
	},
	{
		country: K.Jersey,
		name: "Jersey",
		isoCode2: "JE",
		isoCode3: "JEY",
		aliases: []
	},
	{
		country: K.Jordan,
		name: "Jordan",
		isoCode2: "JO",
		isoCode3: "JOR",
		aliases: []
	},
	{
		country: K.Japan,
		name: "Japan",
		isoCode2: "JP",
		isoCode3: "JPN",
		aliases: []
	},
	{
		country: K.Kazakhstan,
		name: "Kazakhstan",
		isoCode2: "KZ",
		isoCode3: "KAZ",
		aliases: []
	},
	{
		country: K.Kenya,
		name: "Kenya",
		isoCode2: "KE",
		isoCode3: "KEN",
		aliases: []
	},
	{
		country: K.Kyrgyzstan,
		name: "Kyrgyzstan",
		isoCode2: "KG",
		isoCode3: "KGZ",
		aliases: []
	},
	{
		country: K.Cambodia,
		name: "Cambodia",
		isoCode2: "KH",
		isoCode3: "KHM",
		aliases: []
	},
	{
		country: K.Kiribati,
		name: "Kiribati",
		isoCode2: "KI",
		isoCode3: "KIR",
		aliases: []
	},
	{
		country: K.SaintKittsAndNevis,
		name: "Saint Kitts and Nevis",
		isoCode2: "KN",
		isoCode3: "KNA",
		aliases: []
	},
	{
		country: K.SouthKorea,
		name: "South Korea",
		isoCode2: "KR",
		isoCode3: "KOR",
		aliases: ["Korea, Republic of", "Republic of Korea"]
	},
	{
		country: K.Kuwait,
		name: "Kuwait",
		isoCode2: "KW",
		isoCode3: "KWT",
		aliases: []
	},
	{
		country: K.Laos,
		name: "Laos",
		isoCode2: "LA",
		isoCode3: "LAO",
		aliases: ["Lao People's Democratic Republic"]
	},
	{
		country: K.Lebanon,
		name: "Lebanon",
		isoCode2: "LB",
		isoCode3: "LBN",
		aliases: []
	},
	{
		country: K.Liberia,
		name: "Liberia",
		isoCode2: "LR",
		isoCode3: "LBR",
		aliases: []
	},
	{
		country: K.Libya,
		name: "Libya",
		isoCode2: "LY",
		isoCode3: "LBY",
		aliases: []
	},
	{
		country: K.SaintLucia,
		name: "Saint Lucia",
		isoCode2: "LC",
		isoCode3: "LCA",
		aliases: []
	},
	{
		country: K.Liechtenstein,
		name: "Liechtenstein",
		isoCode2: "LI",
		isoCode3: "LIE",
		aliases: []
	},
	{
		country: K.SriLanka,
		name: "Sri Lanka",
		isoCode2: "LK",
		isoCode3: "LKA",
		aliases: []
	},
	{
		country: K.Lesotho,
		name: "Lesotho",
		isoCode2: "LS",
		isoCode3: "LSO",
		aliases: []
	},
	{
		country: K.Lithuania,
		name: "Lithuania",
		isoCode2: "LT",
		isoCode3: "LTU",
		aliases: []
	},
	{
		country: K.Luxembourg,
		name: "Luxembourg",
		isoCode2: "LU",
		isoCode3: "LUX",
		aliases: []
	},
	{
		country: K.Latvia,
		name: "Latvia",
		isoCode2: "LV",
		isoCode3: "LVA",
		aliases: []
	},
	{
		country: K.Macau,
		name: "Macau",
		isoCode2: "MO",
		isoCode3: "MAC",
		aliases: ["Macao"]
	},
	{
		country: K.SaintMartin,
		name: "Saint Martin",
		isoCode2: "MF",
		isoCode3: "MAF",
		aliases: ["Saint Martin (French part)"]
	},
	{
		country: K.Morocco,
		name: "Morocco",
		isoCode2: "MA",
		isoCode3: "MAR",
		aliases: []
	},
	{
		country: K.Monaco,
		name: "Monaco",
		isoCode2: "MC",
		isoCode3: "MCO",
		aliases: []
	},
	{
		country: K.Moldova,
		name: "Moldova",
		isoCode2: "MD",
		isoCode3: "MDA",
		aliases: ["Moldova, Republic of"]
	},
	{
		country: K.Madagascar,
		name: "Madagascar",
		isoCode2: "MG",
		isoCode3: "MDG",
		aliases: []
	},
	{
		country: K.Maldives,
		name: "Maldives",
		isoCode2: "MV",
		isoCode3: "MDV",
		aliases: []
	},
	{
		country: K.Mexico,
		name: "Mexico",
		isoCode2: "MX",
		isoCode3: "MEX",
		aliases: []
	},
	{
		country: K.MarshallIslands,
		name: "Marshall Islands",
		isoCode2: "MH",
		isoCode3: "MHL",
		aliases: []
	},
	{
		country: K.NorthMacedonia,
		name: "North Macedonia",
		isoCode2: "MK",
		isoCode3: "MKD",
		aliases: []
	},
	{
		country: K.Mali,
		name: "Mali",
		isoCode2: "ML",
		isoCode3: "MLI",
		aliases: []
	},
	{
		country: K.Malta,
		name: "Malta",
		isoCode2: "MT",
		isoCode3: "MLT",
		aliases: []
	},
	{
		country: K.Myanmar,
		name: "Myanmar",
		isoCode2: "MM",
		isoCode3: "MMR",
		aliases: []
	},
	{
		country: K.Montenegro,
		name: "Montenegro",
		isoCode2: "ME",
		isoCode3: "MNE",
		aliases: []
	},
	{
		country: K.Mongolia,
		name: "Mongolia",
		isoCode2: "MN",
		isoCode3: "MNG",
		aliases: []
	},
	{
		country: K.NorthernMarianaIslands,
		name: "Northern Mariana Islands",
		isoCode2: "MP",
		isoCode3: "MNP",
		aliases: []
	},
	{
		country: K.Mozambique,
		name: "Mozambique",
		isoCode2: "MZ",
		isoCode3: "MOZ",
		aliases: []
	},
	{
		country: K.Mauritania,
		name: "Mauritania",
		isoCode2: "MR",
		isoCode3: "MRT",
		aliases: []
	},
	{
		country: K.Montserrat,
		name: "Montserrat",
		isoCode2: "MS",
		isoCode3: "MSR",
		aliases: []
	},
	{
		country: K.Martinique,
		name: "Martinique",
		isoCode2: "MQ",
		isoCode3: "MTQ",
		aliases: []
	},
	{
		country: K.Mauritius,
		name: "Mauritius",
		isoCode2: "MU",
		isoCode3: "MUS",
		aliases: []
	},
	{
		country: K.Malawi,
		name: "Malawi",
		isoCode2: "MW",
		isoCode3: "MWI",
		aliases: []
	},
	{
		country: K.Malaysia,
		name: "Malaysia",
		isoCode2: "MY",
		isoCode3: "MYS",
		aliases: []
	},
	{
		country: K.Mayotte,
		name: "Mayotte",
		isoCode2: "YT",
		isoCode3: "MYT",
		aliases: []
	},
	{
		country: K.Namibia,
		name: "Namibia",
		isoCode2: "NA",
		isoCode3: "NAM",
		aliases: []
	},
	{
		country: K.NewCaledonia,
		name: "New Caledonia",
		isoCode2: "NC",
		isoCode3: "NCL",
		aliases: []
	},
	{
		country: K.Niger,
		name: "Niger",
		isoCode2: "NE",
		isoCode3: "NER",
		aliases: []
	},
	{
		country: K.NorfolkIsland,
		name: "Norfolk Island",
		isoCode2: "NF",
		isoCode3: "NFK",
		aliases: []
	},
	{
		country: K.Nigeria,
		name: "Nigeria",
		isoCode2: "NG",
		isoCode3: "NGA",
		aliases: []
	},
	{
		country: K.Nicaragua,
		name: "Nicaragua",
		isoCode2: "NI",
		isoCode3: "NIC",
		aliases: []
	},
	{
		country: K.Niue,
		name: "Niue",
		isoCode2: "NU",
		isoCode3: "NIU",
		aliases: []
	},
	{
		country: K.Netherlands,
		name: "Netherlands",
		isoCode2: "NL",
		isoCode3: "NLD",
		aliases: []
	},
	{
		country: K.Norway,
		name: "Norway",
		isoCode2: "NO",
		isoCode3: "NOR",
		aliases: []
	},
	{
		country: K.Nepal,
		name: "Nepal",
		isoCode2: "NP",
		isoCode3: "NPL",
		aliases: []
	},
	{
		country: K.Nauru,
		name: "Nauru",
		isoCode2: "NR",
		isoCode3: "NRU",
		aliases: []
	},
	{
		country: K.NewZealand,
		name: "New Zealand",
		isoCode2: "NZ",
		isoCode3: "NZL",
		aliases: []
	},
	{
		country: K.Oman,
		name: "Oman",
		isoCode2: "OM",
		isoCode3: "OMN",
		aliases: []
	},
	{
		country: K.Pakistan,
		name: "Pakistan",
		isoCode2: "PK",
		isoCode3: "PAK",
		aliases: []
	},
	{
		country: K.Panama,
		name: "Panama",
		isoCode2: "PA",
		isoCode3: "PAN",
		aliases: []
	},
	{
		country: K.Pitcairn,
		name: "Pitcairn",
		isoCode2: "PN",
		isoCode3: "PCN",
		aliases: []
	},
	{
		country: K.Peru,
		name: "Peru",
		isoCode2: "PE",
		isoCode3: "PER",
		aliases: []
	},
	{
		country: K.Philippines,
		name: "Philippines",
		isoCode2: "PH",
		isoCode3: "PHL",
		aliases: []
	},
	{
		country: K.Palau,
		name: "Palau",
		isoCode2: "PW",
		isoCode3: "PLW",
		aliases: []
	},
	{
		country: K.PapuaNewGuinea,
		name: "Papua New Guinea",
		isoCode2: "PG",
		isoCode3: "PNG",
		aliases: []
	},
	{
		country: K.Poland,
		name: "Poland",
		isoCode2: "PL",
		isoCode3: "POL",
		aliases: []
	},
	{
		country: K.PuertoRico,
		name: "Puerto Rico",
		isoCode2: "PR",
		isoCode3: "PRI",
		aliases: []
	},
	{
		country: K.NorthKorea,
		name: "North Korea",
		isoCode2: "KP",
		isoCode3: "PRK",
		aliases: ["Korea, Democratic People's Republic of", "Democratic People's Republic of Korea"]
	},
	{
		country: K.Portugal,
		name: "Portugal",
		isoCode2: "PT",
		isoCode3: "PRT",
		aliases: []
	},
	{
		country: K.Paraguay,
		name: "Paraguay",
		isoCode2: "PY",
		isoCode3: "PRY",
		aliases: []
	},
	{
		country: K.Palestine,
		name: "Palestine",
		isoCode2: "PS",
		isoCode3: "PSE",
		aliases: ["Palestine, State of"]
	},
	{
		country: K.FrenchPolynesia,
		name: "French Polynesia",
		isoCode2: "PF",
		isoCode3: "PYF",
		aliases: []
	},
	{
		country: K.Qatar,
		name: "Qatar",
		isoCode2: "QA",
		isoCode3: "QAT",
		aliases: []
	},
	{
		country: K.Reunion,
		name: "Reunion",
		isoCode2: "RE",
		isoCode3: "REU",
		aliases: ["Réunion"]
	},
	{
		country: K.Romania,
		name: "Romania",
		isoCode2: "RO",
		isoCode3: "ROU",
		aliases: []
	},
	{
		country: K.Russia,
		name: "Russia",
		isoCode2: "RU",
		isoCode3: "RUS",
		aliases: ["Russian Federation"]
	},
	{
		country: K.Rwanda,
		name: "Rwanda",
		isoCode2: "RW",
		isoCode3: "RWA",
		aliases: []
	},
	{
		country: K.SaudiArabia,
		name: "Saudi Arabia",
		isoCode2: "SA",
		isoCode3: "SAU",
		aliases: []
	},
	{
		country: K.Sudan,
		name: "Sudan",
		isoCode2: "SD",
		isoCode3: "SDN",
		aliases: []
	},
	{
		country: K.Senegal,
		name: "Senegal",
		isoCode2: "SN",
		isoCode3: "SEN",
		aliases: []
	},
	{
		country: K.Singapore,
		name: "Singapore",
		isoCode2: "SG",
		isoCode3: "SGP",
		aliases: []
	},
	{
		country: K.SouthGeorgiaAndTheSouthSandwichIslands,
		name: "South Georgia and the South Sandwich Islands",
		isoCode2: "GS",
		isoCode3: "SGS",
		aliases: []
	},
	{
		country: K.SaintHelena,
		name: "Saint Helena",
		isoCode2: "SH",
		isoCode3: "SHN",
		aliases: ["Saint Helena, Ascension and Tristan da Cunha"]
	},
	{
		country: K.SvalbardAndJanMayen,
		name: "Svalbard and Jan Mayen",
		isoCode2: "SJ",
		isoCode3: "SJM",
		aliases: []
	},
	{
		country: K.SolomonIslands,
		name: "Solomon Islands",
		isoCode2: "SB",
		isoCode3: "SLB",
		aliases: []
	},
	{
		country: K.SierraLeone,
		name: "Sierra Leone",
		isoCode2: "SL",
		isoCode3: "SLE",
		aliases: []
	},
	{
		country: K.ElSalvador,
		name: "El Salvador",
		isoCode2: "SV",
		isoCode3: "SLV",
		aliases: []
	},
	{
		country: K.SanMarino,
		name: "San Marino",
		isoCode2: "SM",
		isoCode3: "SMR",
		aliases: []
	},
	{
		country: K.Somalia,
		name: "Somalia",
		isoCode2: "SO",
		isoCode3: "SOM",
		aliases: []
	},
	{
		country: K.SaintPierreAndMiquelon,
		name: "Saint Pierre and Miquelon",
		isoCode2: "PM",
		isoCode3: "SPM",
		aliases: []
	},
	{
		country: K.Serbia,
		name: "Serbia",
		isoCode2: "RS",
		isoCode3: "SRB",
		aliases: []
	},
	{
		country: K.SouthSudan,
		name: "South Sudan",
		isoCode2: "SS",
		isoCode3: "SSD",
		aliases: []
	},
	{
		country: K.SaoTomeAndPrincipe,
		name: "Sao Tome and Principe",
		isoCode2: "ST",
		isoCode3: "STP",
		aliases: []
	},
	{
		country: K.Suriname,
		name: "Suriname",
		isoCode2: "SR",
		isoCode3: "SUR",
		aliases: []
	},
	{
		country: K.Slovakia,
		name: "Slovakia",
		isoCode2: "SK",
		isoCode3: "SVK",
		aliases: []
	},
	{
		country: K.Slovenia,
		name: "Slovenia",
		isoCode2: "SI",
		isoCode3: "SVN",
		aliases: []
	},
	{
		country: K.Sweden,
		name: "Sweden",
		isoCode2: "SE",
		isoCode3: "SWE",
		aliases: []
	},
	{
		country: K.Swaziland,
		name: "Swaziland",
		isoCode2: "SZ",
		isoCode3: "SWZ",
		aliases: ["Eswatini"]
	},
	{
		country: K.SintMaarten,
		name: "Sint Maarten",
		isoCode2: "SX",
		isoCode3: "SXM",
		aliases: ["Sint Maarten (Dutch part)"]
	},
	{
		country: K.Seychelles,
		name: "Seychelles",
		isoCode2: "SC",
		isoCode3: "SYC",
		aliases: []
	},
	{
		country: K.Syria,
		name: "Syria",
		isoCode2: "SY",
		isoCode3: "SYR",
		aliases: ["Syrian Arab Republic"]
	},
	{
		country: K.TurksAndCaicosIslands,
		name: "Turks and Caicos Islands",
		isoCode2: "TC",
		isoCode3: "TCA",
		aliases: []
	},
	{
		country: K.Chad,
		name: "Chad",
		isoCode2: "TD",
		isoCode3: "TCD",
		aliases: []
	},
	{
		country: K.Togo,
		name: "Togo",
		isoCode2: "TG",
		isoCode3: "TGO",
		aliases: []
	},
	{
		country: K.Thailand,
		name: "Thailand",
		isoCode2: "TH",
		isoCode3: "THA",
		aliases: []
	},
	{
		country: K.Tajikistan,
		name: "Tajikistan",
		isoCode2: "TJ",
		isoCode3: "TJK",
		aliases: []
	},
	{
		country: K.Tokelau,
		name: "Tokelau",
		isoCode2: "TK",
		isoCode3: "TKL",
		aliases: []
	},
	{
		country: K.Turkmenistan,
		name: "Turkmenistan",
		isoCode2: "TM",
		isoCode3: "TKM",
		aliases: []
	},
	{
		country: K.EastTimor,
		name: "East Timor",
		isoCode2: "TL",
		isoCode3: "TLS",
		aliases: ["Timor-Leste"]
	},
	{
		country: K.Tonga,
		name: "Tonga",
		isoCode2: "TO",
		isoCode3: "TON",
		aliases: []
	},
	{
		country: K.TrinidadAndTobago,
		name: "Trinidad and Tobago",
		isoCode2: "TT",
		isoCode3: "TTO",
		aliases: []
	},
	{
		country: K.Tunisia,
		name: "Tunisia",
		isoCode2: "TN",
		isoCode3: "TUN",
		aliases: []
	},
	{
		country: K.Turkey,
		name: "Turkey",
		isoCode2: "TR",
		isoCode3: "TUR",
		aliases: ["Türkiye"]
	},
	{
		country: K.Tuvalu,
		name: "Tuvalu",
		isoCode2: "TV",
		isoCode3: "TUV",
		aliases: []
	},
	{
		country: K.Taiwan,
		name: "Taiwan",
		isoCode2: "TW",
		isoCode3: "TWN",
		aliases: ["Taiwan, Province of China"]
	},
	{
		country: K.Tanzania,
		name: "Tanzania",
		isoCode2: "TZ",
		isoCode3: "TZA",
		aliases: ["Tanzania, United Republic of"]
	},
	{
		country: K.Uganda,
		name: "Uganda",
		isoCode2: "UG",
		isoCode3: "UGA",
		aliases: []
	},
	{
		country: K.Ukraine,
		name: "Ukraine",
		isoCode2: "UA",
		isoCode3: "UKR",
		aliases: []
	},
	{
		country: K.UnitedStatesMinorOutlyingIslands,
		name: "United States Minor Outlying Islands",
		isoCode2: "UM",
		isoCode3: "UMI",
		aliases: []
	},
	{
		country: K.Uruguay,
		name: "Uruguay",
		isoCode2: "UY",
		isoCode3: "URY",
		aliases: []
	},
	{
		country: K.UnitedStates,
		name: "United States",
		isoCode2: "US",
		isoCode3: "USA",
		aliases: []
	},
	{
		country: K.Uzbekistan,
		name: "Uzbekistan",
		isoCode2: "UZ",
		isoCode3: "UZB",
		aliases: []
	},
	{
		country: K.VaticanCity,
		name: "Vatican City",
		isoCode2: "VA",
		isoCode3: "VAT",
		aliases: ["Holy See (Vatican City State)", "Holy See"]
	},
	{
		country: K.SaintVincentAndTheGrenadines,
		name: "Saint Vincent and the Grenadines",
		isoCode2: "VC",
		isoCode3: "VCT",
		aliases: []
	},
	{
		country: K.Venezuela,
		name: "Venezuela",
		isoCode2: "VE",
		isoCode3: "VEN",
		aliases: ["Venezuela, Bolivarian Republic of"]
	},
	{
		country: K.BritishVirginIslands,
		name: "British Virgin Islands",
		isoCode2: "VG",
		isoCode3: "VGB",
		aliases: ["Virgin Islands, British"]
	},
	{
		country: K.USVirginIslands,
		name: "U.S. Virgin Islands",
		isoCode2: "VI",
		isoCode3: "VIR",
		aliases: ["Virgin Islands, U.S.", "US Virgin Islands"]
	},
	{
		country: K.Vietnam,
		name: "Vietnam",
		isoCode2: "VN",
		isoCode3: "VNM",
		aliases: ["Viet Nam"]
	},
	{
		country: K.Vanuatu,
		name: "Vanuatu",
		isoCode2: "VU",
		isoCode3: "VUT",
		aliases: []
	},
	{
		country: K.WallisAndFutuna,
		name: "Wallis and Futuna",
		isoCode2: "WF",
		isoCode3: "WLF",
		aliases: []
	},
	{
		country: K.Samoa,
		name: "Samoa",
		isoCode2: "WS",
		isoCode3: "WSM",
		aliases: []
	},
	{
		country: K.Yemen,
		name: "Yemen",
		isoCode2: "YE",
		isoCode3: "YEM",
		aliases: []
	},
	{
		country: K.SouthAfrica,
		name: "South Africa",
		isoCode2: "ZA",
		isoCode3: "ZAF",
		aliases: []
	},
	{
		country: K.Zambia,
		name: "Zambia",
		isoCode2: "ZM",
		isoCode3: "ZMB",
		aliases: []
	},
	{
		country: K.Zimbabwe,
		name: "Zimbabwe",
		isoCode2: "ZW",
		isoCode3: "ZWE",
		aliases: []
	}
], q = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isCampaignsApiException = !0;
	static isCampaignsApiException(e) {
		return e.isCampaignsApiException === !0;
	}
};
function J(e, t, n, r, i) {
	throw i ?? new q(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var Y = "campaigns";
function mr(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var X = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), mr(r);
}, hr = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[Y] || `${e}/${Y}`;
}, Z = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = hr(i), u = c, d = X(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = X(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, Q = a({}), gr = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = Z(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(Q.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, _r = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, documentType: n, body: r, contractId: i, filePath: a } = e;
		return s.addOrUpdateDocument(t, n, r, i, a);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		addOrUpdateDocument: d,
		addOrUpdateDocumentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, vr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.beginCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		beginCampaign: d,
		beginCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, yr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.completeCampaignStep(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		completeCampaignStep: d,
		completeCampaignStepPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, br = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.constructConditionClauseText(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		constructConditionClauseText: d,
		constructConditionClauseTextPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, xr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.convertAgentExchangeToSalesAdvice(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		convertAgentExchangeToSalesAdvice: d,
		convertAgentExchangeToSalesAdvicePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Sr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.convertSalesAdviceToAgentExchange(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		convertSalesAdviceToAgentExchange: d,
		convertSalesAdviceToAgentExchangePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Cr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.devCreateContractTestCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		devCreateContractTestCampaign: d,
		devCreateContractTestCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, wr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.exchangeContract(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		exchangeContract: d,
		exchangeContractPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Tr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async () => s.formsByLocations(), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		formsByLocations: d,
		formsByLocationsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Er = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getActiveCampaigns"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getActiveCampaigns(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Dr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getActiveCampaigns"] });
	}, e[0] = t, e[1] = n), n;
}, Or = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getAgreementReadiness",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getAgreementReadiness(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, kr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getAgreementReadiness",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Ar = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getArchivedCampaignsByAdmin", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getArchivedCampaignsByAdmin(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, jr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAdmin", e] });
	}, e[0] = t, e[1] = n), n;
}, Mr = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getArchivedCampaignsByAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getArchivedCampaignsByAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Nr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAgency"] });
	}, e[0] = t, e[1] = n), n;
}, Pr = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Fr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ir = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaignsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaignsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Lr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaignsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, Rr = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getProposalPresentationDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getProposalPresentationDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, zr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getProposalPresentationDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, Br = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getProposalPresentationSources", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getProposalPresentationSources(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Vr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getProposalPresentationSources", e] });
	}, e[0] = t, e[1] = n), n;
}, Hr = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getSpecialConditionBank"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getSpecialConditionBank(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Ur = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getSpecialConditionBank"] });
	}, e[0] = t, e[1] = n), n;
}, Wr = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Gr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, Kr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.importProposalImage(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		importProposalImage: d,
		importProposalImagePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, qr = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"loadForm",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.loadForm(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Jr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"loadForm",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Yr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async () => s.negotiate(), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		negotiate: d,
		negotiatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Xr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.performCampaignAction(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		performCampaignAction: d,
		performCampaignActionPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Zr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.performContractAction(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		performContractAction: d,
		performContractActionPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Qr = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.removeFile(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		removeFile: d,
		removeFilePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, $r = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.removeFormSubmission(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		removeFormSubmission: d,
		removeFormSubmissionPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ei = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.saveForm(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		saveForm: d,
		saveFormPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ti = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.sendForm(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		sendForm: d,
		sendFormPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ni = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setCampaignOwnership(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setCampaignOwnership: d,
		setCampaignOwnershipPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ri = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffBeginCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffBeginCampaign: d,
		staffBeginCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ii = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return s.staffCreateContractDepositRelease(t, n, r);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffCreateContractDepositRelease: d,
		staffCreateContractDepositReleasePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ai = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAgreementDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAgreementDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, oi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAgreementDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, si = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBlankContractDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBlankContractDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ci = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBlankContractDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, li = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyers(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ui = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyers", e] });
	}, e[0] = t, e[1] = n), n;
}, di = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersAgent", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersAgent(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, fi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersAgent", e] });
	}, e[0] = t, e[1] = n), n;
}, pi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersSolicitor", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersSolicitor(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, mi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersSolicitor", e] });
	}, e[0] = t, e[1] = n), n;
}, hi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, gi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, _i = (e, t, n, i, a, s, c, l, d, f, p) => {
	let m = r(31), h = p === void 0 || p, g = o(Q), _;
	m[0] !== c || m[1] !== e || m[2] !== s || m[3] !== n || m[4] !== l || m[5] !== i || m[6] !== a || m[7] !== d || m[8] !== f || m[9] !== t ? (_ = [
		"staffGetCampaignDashboard",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d,
		f
	], m[0] = c, m[1] = e, m[2] = s, m[3] = n, m[4] = l, m[5] = i, m[6] = a, m[7] = d, m[8] = f, m[9] = t, m[10] = _) : _ = m[10];
	let v = _, y;
	m[11] !== c || m[12] !== e || m[13] !== g || m[14] !== s || m[15] !== n || m[16] !== l || m[17] !== i || m[18] !== a || m[19] !== d || m[20] !== f || m[21] !== t ? (y = (r) => {
		let { signal: o } = r;
		return g.staffGetCampaignDashboard(e, t, n, i, a, s, c, l, d, f, o);
	}, m[11] = c, m[12] = e, m[13] = g, m[14] = s, m[15] = n, m[16] = l, m[17] = i, m[18] = a, m[19] = d, m[20] = f, m[21] = t, m[22] = y) : y = m[22];
	let b = h && !!g, x;
	m[23] !== v || m[24] !== y || m[25] !== b ? (x = {
		queryKey: v,
		queryFn: y,
		enabled: b
	}, m[23] = v, m[24] = y, m[25] = b, m[26] = x) : x = m[26];
	let { data: S, isPending: C, isError: w } = u(x), T;
	return m[27] !== S || m[28] !== w || m[29] !== C ? (T = {
		data: S,
		isPending: C,
		isError: w
	}, m[27] = S, m[28] = w, m[29] = C, m[30] = T) : T = m[30], T;
}, vi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l, u) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetCampaignDashboard",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l,
			u
		] });
	}, e[0] = t, e[1] = n), n;
}, yi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCampaignOverview", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCampaignOverview(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, bi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCampaignOverview", e] });
	}, e[0] = t, e[1] = n), n;
}, xi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCommissionInfoForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCommissionInfoForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Si = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCommissionInfoForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ci = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContract", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContract(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, wi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContract", e] });
	}, e[0] = t, e[1] = n), n;
}, Ti = (e, t, n, i, a, s, c, l) => {
	let d = r(25), f = l === void 0 || l, p = o(Q), m;
	d[0] !== s || d[1] !== e || d[2] !== n || d[3] !== i || d[4] !== c || d[5] !== t || d[6] !== a ? (m = [
		"staffGetContractDashboard",
		e,
		t,
		n,
		i,
		a,
		s,
		c
	], d[0] = s, d[1] = e, d[2] = n, d[3] = i, d[4] = c, d[5] = t, d[6] = a, d[7] = m) : m = d[7];
	let h = m, g;
	d[8] !== s || d[9] !== e || d[10] !== p || d[11] !== n || d[12] !== i || d[13] !== c || d[14] !== t || d[15] !== a ? (g = (r) => {
		let { signal: o } = r;
		return p.staffGetContractDashboard(e, t, n, i, a, s, c, o);
	}, d[8] = s, d[9] = e, d[10] = p, d[11] = n, d[12] = i, d[13] = c, d[14] = t, d[15] = a, d[16] = g) : g = d[16];
	let _ = f && !!p, v;
	d[17] !== h || d[18] !== g || d[19] !== _ ? (v = {
		queryKey: h,
		queryFn: g,
		enabled: _
	}, d[17] = h, d[18] = g, d[19] = _, d[20] = v) : v = d[20];
	let { data: y, isPending: b, isError: x } = u(v), S;
	return d[21] !== y || d[22] !== x || d[23] !== b ? (S = {
		data: y,
		isPending: b,
		isError: x
	}, d[21] = y, d[22] = x, d[23] = b, d[24] = S) : S = d[24], S;
}, Ei = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDashboard",
			e,
			n,
			r,
			i,
			a,
			o,
			s
		] });
	}, e[0] = t, e[1] = n), n;
}, Di = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDates",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDates(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Oi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDates",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ki = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDeposits",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDeposits(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Ai = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDeposits",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ji = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractSettlement",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractSettlement(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Mi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractSettlement",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Ni = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContractsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContractsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Pi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContractsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Fi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetDocumentsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetDocumentsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ii = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetDocumentsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Li = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetExternalConjunction", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetExternalConjunction(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ri = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetExternalConjunction", e] });
	}, e[0] = t, e[1] = n), n;
}, zi = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffGetFormConfiguration(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffGetFormConfiguration: d,
		staffGetFormConfigurationPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Bi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetLaunchDateDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetLaunchDateDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Vi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetLaunchDateDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Hi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPhotosAndMediaDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPhotosAndMediaDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ui = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPhotosAndMediaDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Wi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Gi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ki = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyInformationProgressForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyInformationProgressForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, qi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyInformationProgressForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ji = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSaleInformation",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSaleInformation(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Yi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSaleInformation",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Xi = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSpecialConditions",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSpecialConditions(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Zi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSpecialConditions",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Qi = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetTenancyInformationForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetTenancyInformationForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, $i = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetTenancyInformationForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, ea = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ta = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, na = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetVendorDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetVendorDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ra = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetVendorDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, ia = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return s.staffPreviewLinkedDates(t, n, r);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffPreviewLinkedDates: d,
		staffPreviewLinkedDatesPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, aa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffSaveForm(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffSaveForm: d,
		staffSaveFormPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, $ = (e, t, n, i, a) => {
	let s = r(19), c = a === void 0 || a, l = o(Q), d;
	s[0] !== i || s[1] !== n || s[2] !== t || s[3] !== e ? (d = [
		"staffSearchForCampaign",
		e,
		t,
		n,
		i
	], s[0] = i, s[1] = n, s[2] = t, s[3] = e, s[4] = d) : d = s[4];
	let f = d, p;
	s[5] !== l || s[6] !== i || s[7] !== n || s[8] !== t || s[9] !== e ? (p = (r) => {
		let { signal: a } = r;
		return l.staffSearchForCampaign(e, t, n, i, a);
	}, s[5] = l, s[6] = i, s[7] = n, s[8] = t, s[9] = e, s[10] = p) : p = s[10];
	let m = c && !!l, h;
	s[11] !== f || s[12] !== p || s[13] !== m ? (h = {
		queryKey: f,
		queryFn: p,
		enabled: m
	}, s[11] = f, s[12] = p, s[13] = m, s[14] = h) : h = s[14];
	let { data: g, isPending: _, isError: v } = u(h), y;
	return s[15] !== g || s[16] !== v || s[17] !== _ ? (y = {
		data: g,
		isPending: _,
		isError: v
	}, s[15] = g, s[16] = v, s[17] = _, s[18] = y) : y = s[18], y;
}, oa = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i) => {
		await t.invalidateQueries({ queryKey: [
			"staffSearchForCampaign",
			e,
			n,
			r,
			i
		] });
	}, e[0] = t, e[1] = n), n;
}, sa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffSubmitForm(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffSubmitForm: d,
		staffSubmitFormPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ca = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdateAgreementDetailsForCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateAgreementDetailsForCampaign: d,
		staffUpdateAgreementDetailsForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, la = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, body: n } = e;
		return s.staffUpdateBlankContractDetailsForCampaign(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateBlankContractDetailsForCampaign: d,
		staffUpdateBlankContractDetailsForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ua = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { contractId: t, body: n } = e;
		return s.staffUpdateBuyers(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateBuyers: d,
		staffUpdateBuyersPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, da = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { contractId: t, body: n } = e;
		return s.staffUpdateBuyersAgent(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateBuyersAgent: d,
		staffUpdateBuyersAgentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, fa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { contractId: t, body: n } = e;
		return s.staffUpdateBuyersSolicitor(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateBuyersSolicitor: d,
		staffUpdateBuyersSolicitorPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, pa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdateCommissionInfoForCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateCommissionInfoForCampaign: d,
		staffUpdateCommissionInfoForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ma = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { contractId: t, body: n } = e;
		return s.staffUpdateContractComplianceFields(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateContractComplianceFields: d,
		staffUpdateContractComplianceFieldsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ha = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { contractId: t, body: n } = e;
		return s.staffUpdateContractDates(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateContractDates: d,
		staffUpdateContractDatesPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ga = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { contractId: t, body: n } = e;
		return s.staffUpdateContractDeposits(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateContractDeposits: d,
		staffUpdateContractDepositsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, _a = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return s.staffUpdateContractSettlement(t, n, r);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateContractSettlement: d,
		staffUpdateContractSettlementPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, va = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdateContractSpecialConditionDueDate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateContractSpecialConditionDueDate: d,
		staffUpdateContractSpecialConditionDueDatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ya = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { contractId: t, body: n } = e;
		return s.staffUpdateContractSpecialConditions(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateContractSpecialConditions: d,
		staffUpdateContractSpecialConditionsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ba = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return s.staffUpdateContractTermination(t, n, r);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateContractTermination: d,
		staffUpdateContractTerminationPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, xa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, body: n } = e;
		return s.staffUpdateExternalConjunction(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateExternalConjunction: d,
		staffUpdateExternalConjunctionPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Sa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdateLaunchDateForCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateLaunchDateForCampaign: d,
		staffUpdateLaunchDateForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ca = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdatePhotosAndMediaDetailsForCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdatePhotosAndMediaDetailsForCampaign: d,
		staffUpdatePhotosAndMediaDetailsForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, wa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, body: n } = e;
		return s.staffUpdatePropertyDetailsForCampaign(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdatePropertyDetailsForCampaign: d,
		staffUpdatePropertyDetailsForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ta = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return s.staffUpdateSaleInformation(t, n, r);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateSaleInformation: d,
		staffUpdateSaleInformationPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ea = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdateServiceFeeInfoForCampaign(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateServiceFeeInfoForCampaign: d,
		staffUpdateServiceFeeInfoForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Da = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, body: n } = e;
		return s.staffUpdateTenancyInformationForCampaign(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateTenancyInformationForCampaign: d,
		staffUpdateTenancyInformationForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Oa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, body: n } = e;
		return s.staffUpdateVendorDetailsForCampaign(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateVendorDetailsForCampaign: d,
		staffUpdateVendorDetailsForCampaignPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ka = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return s.staffWithdrawContractOffer(t, n, r);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffWithdrawContractOffer: d,
		staffWithdrawContractOfferPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Aa = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.submitForm(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		submitForm: d,
		submitFormPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ja = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Q), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateProposalPresentationDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateProposalPresentationDetails: d,
		updateProposalPresentationDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { m as AddressSearchStateToSearch, h as AdjustmentCommissionType, g as AdjustmentToCommissionCondition, _ as AgreementReadinessCategoryId, v as AgreementReadinessCategoryStatus, y as AgreementReadinessEditTargetSurface, b as AgreementReadinessErrorCode, x as AgreementReadinessResponseState, S as AgreementReadinessWorkItemStatus, C as AgreementType, w as AlertType, T as AndOr, ee as AustralianState, te as BasicCampaignDetailsModelStage, ne as BasicCampaignDetailsModelState, re as BeginCampaignState, ie as BlankContractStatuses, ae as BodyCorporateType, oe as BuiltOnOrVacantLandType, se as CampaignActionRequestCampaignAction, ce as CampaignAdminModelMarketingStatus, E as CampaignAdminModelStage, D as CampaignAdminModelState, O as CampaignCompletionStateCompletionType, k as CampaignDashboardLaunchStatus, A as CampaignDashboardRowMarketingStatus, j as CampaignDetailModelBlankSalesContractStatus, M as CampaignDetailModelStage, N as CampaignDetailModelState, P as CampaignSearchResultContractStage, F as CampaignSearchResultStage, I as CampaignStatuses, Q as CampaignsApiContext, q as CampaignsApiException, gr as CampaignsApiProvider, p as CampaignsClient, Y as CampaignsRoute, L as Chattel, R as Chattels, z as CommissionDetailsChangeInfoChangeType, B as CommissionTypes, V as CommunityTitlesSchemeDocumentType, H as ComparativeType, U as Condition, W as ConditionType, G as ConditionalTextInputType, le as ContractActionRequestContractAction, ue as ContractCompletionType, de as ContractConditionType, fe as ContractDashboardRowVendorBankDetailsStatus, pe as ContractDatesConditionConfigContractDateType, me as ContractDepositReleaseAvailabilityState, he as ContractStatuses, ge as ContractType, _e as CoolingOffCondition, ve as CoolingOffType, K as Country, ye as CustomPdfScript, be as DayType, xe as DepositPayable, Se as DepositPaymentType, Ce as DepositType, we as DevCreateContractTestCampaignRequestAgreementSource, Te as DevCreateContractTestCampaignRequestContract, Ee as DevCreateContractTestCampaignRequestContractConditions, De as DevCreateContractTestCampaignRequestContractCreationSource, Oe as DevCreateContractTestCampaignRequestContractStage, ke as DevCreateContractTestCampaignRequestCreateFrom, Ae as DevCreateContractTestCampaignRequestDepositProfile, je as DevCreateContractTestCampaignRequestListingLaunch, Me as DevCreateContractTestCampaignRequestState, Ne as DocuSignInfoCondition, Pe as DocumentTypes, Fe as EditScope, Ie as EditablePdfButtonPdfFieldType, Le as EditablePdfButtonType, Re as EditablePdfUploadCustomScript, ze as EditablePdfUploadDocumentType, Be as ElementType, Ve as EmploymentType, He as EnvelopeSubmissionModelStatus, Ue as EnvelopeSubmissionModelType, We as EnvelopeSubmissionRecipientStatus, Ge as ExternalConjunctionConjunctionFeeType, Ke as FileUploadDocumentType, qe as FlatCommissionType, Je as FormConfigurationRequestFormType, Ye as FormDetailsFlow, Xe as FormDetailsState, Ze as FormDetailsType, Qe as FormPageActionButtonType, $e as FormPageSubmitType, et as FormState, tt as FormSubmissionRequestFormType, nt as FormSubmissionRequestState, rt as FormType, it as IdentityDocument, at as IdentityVerificationDocumentSighted, ot as IdentityVerificationExportsAggregateStatus, st as IdentityVerificationExportsModelAggregateStatus, ct as IdentityVerificationProofOfOwnershipDocument, lt as InProgressFormModelFormType, ut as IsoDayOfWeek, dt as LandAreaType, ft as LaunchDateDetailsStatus, pt as LaunchDateStatus, mt as LaunchDateStatuses, ht as LaunchDetailsStatus, gt as LegalOwnershipDocument, _t as LinkedDateImpactSourceDateType, vt as MarketingStatuses, yt as NoCoolingOffReason, bt as NswContractRequestModelDisplaySalePriceOnceSold, xt as NswContractSubmissionModelDisplaySalePriceOnceSold, St as NswListingGeneratorModelVendorWaivingCoolingOffPeriod, Ct as NswListingSubmissionModelHasContractAlreadyBeenRequested, wt as Operator, Tt as OwnerBuilderDeclarationCustomScript, Et as OwnerBuilderDeclarationDocumentType, Dt as OwnershipStructure, Ot as PageStatusStatus, kt as PlaceOfIssue, At as PoolDocumentationType, jt as PoolSafetyFileType, Mt as PresentationUploadItemDocumentType, Nt as PresentationUploadItemStatus, Pt as ProposalImageCandidateDocumentType, Ft as QldContractRequestModelAcquiringLandForTaxPurpose, It as QldContractRequestModelDisplayTenantDetailsOnContract, Lt as QldContractRequestModelIncludeBuyerDetailsOnContract, Rt as QldContractRequestModelIncludeVendorDetailsOnContract, zt as QldContractSubmissionModelDisplaySalePriceOnceSold, Bt as QldListingSubmissionModelApprovedSafetySwitchInstalled, Vt as QldListingSubmissionModelCompliesWithSmokeAlarmLegislation, Ht as QldListingSubmissionModelGstIsPaymentRequired, Ut as QldListingSubmissionModelIncludeVendorDetailsOnContract, Wt as QldListingSubmissionModelNeighbourhoodDisputes, Gt as QueenslandBlankContractModelApprovedSafetySwitchInstalled, Kt as QueenslandBlankContractModelCompliesWithSmokeAlarmLegislation, qt as QueenslandBlankContractModelGstIsPaymentRequired, Jt as QueenslandBlankContractModelIncludeVendorDetailsOnContract, Yt as QueenslandBlankContractModelNeighbourhoodDisputes, Xt as QueenslandListingGeneratorModelApprovedSafetySwitchInstalled, Zt as QueenslandListingGeneratorModelCompliesWithSmokeAlarmLegislation, Qt as QueenslandListingGeneratorModelNeighbourhoodDisputes, $t as ReasonForTransaction, en as RenderedSpecialConditionConditionType, tn as RentPeriod, nn as ResultType, rn as RuralType, an as SaleDetailsState, on as SaleType, sn as SecondaryIdentityDocument, cn as SecondaryIdentityDocuments, ln as SellersDisclosurePreparedBy, un as SellersDisclosurePreparedByModelPreparedBy, dn as SellersDisclosureUploadCustomScript, fn as SellersDisclosureUploadDocumentType, pn as SendForDocuSigningType, mn as SendFormSubmissionModelFormType, hn as SendFormSubmissionModelState, gn as ServiceFeeDetailsChangeInfoChangeType, _n as SettlementDateStatuses, vn as SignboardRemovalRemovalType, yn as SignboardRemovalType, bn as SigningOrderGroups, xn as SolicitorType, Sn as SortingOption, Cn as SortingOptionContractDashboard, wn as SpecialConditionBankTemplateConditionType, Tn as SpecialConditionDataConditionType, En as StaffBeginCampaignRequestState, Dn as StaffContractDepositReleaseDestinationOfTransfer, On as StaffCreateContractDepositReleaseRequestDestinationOfTransfer, kn as StaffGetBlankContractDetailsForCampaignResponseBlankSalesContractStatus, An as StaffGetCampaignOverviewResponseVendorCommunicationPreference, jn as StaffGetCommissionInfoForCampaignModelPartnershipLevel, Mn as StaffGetContractSettlementResponseSettlementType, Nn as StaffGetSaleInformationResponseSaleMethod, Pn as StaffGetSaleInformationResponseUnconditionalDisplayAs, Fn as StaffGetSaleInformationResponseUnderOfferDisplayAs, In as StaffPreviewLinkedDatesRequestSourceDateType, Ln as StaffUpdateBlankContractDetailsForCampaignRequestBlankSalesContractStatus, Rn as StaffUpdateCommissionInfoForCampaignRequestChangeType, zn as StaffUpdateContractSettlementRequestSettlementType, Bn as StaffUpdateContractTerminationRequestContractTerminationReasons, Vn as StaffUpdateContractTerminationRequestDepositEntitlement, Hn as StaffUpdateLaunchDateForCampaignRequestStatus, Un as StaffUpdateSaleInformationRequestSaleMethod, Wn as StaffUpdateSaleInformationRequestUnconditionalDisplayAs, Gn as StaffUpdateSaleInformationRequestUnderOfferDisplayAs, Kn as StaffUpdateServiceFeeInfoForCampaignRequestChangeType, qn as StakeholderType, Jn as States, Yn as SurveyPlanUploadDocumentType, Xn as TenancyModelTerm, Zn as TenancyTerm, Qn as TenancyType, $n as TieredSystemType, er as TimeUnit, tr as TypedFormDocumentModelDocumentType, nr as UploadedDocumentDocumentType, rr as UploadedDocumentInfoDocumentType, ir as UploadedDocumentInfoSigningMethod, ar as UploadedPOADocumentModelDocumentType, or as ValueType, sr as VendorBankDetailsStatuses, cr as VendorBuyerType, lr as VendorBuyerTypes, ur as VendorCommPreference, dr as VerificationMethod, fr as YesNoQuestion, pr as countriesDefinitions, _r as useAddOrUpdateDocument, vr as useBeginCampaign, Z as useCampaignsClientContext, yr as useCompleteCampaignStep, br as useConstructConditionClauseText, xr as useConvertAgentExchangeToSalesAdvice, Sr as useConvertSalesAdviceToAgentExchange, Cr as useDevCreateContractTestCampaign, wr as useExchangeContract, Tr as useFormsByLocations, Er as useGetActiveCampaigns, Or as useGetAgreementReadiness, Ar as useGetArchivedCampaignsByAdmin, Mr as useGetArchivedCampaignsByAgency, Pr as useGetCampaign, Ir as useGetCampaignsForAgency, Rr as useGetProposalPresentationDetails, Br as useGetProposalPresentationSources, Hr as useGetSpecialConditionBank, Wr as useGetUploadedFileLink, Kr as useImportProposalImage, Dr as useInvalidateUseGetActiveCampaigns, kr as useInvalidateUseGetAgreementReadiness, jr as useInvalidateUseGetArchivedCampaignsByAdmin, Nr as useInvalidateUseGetArchivedCampaignsByAgency, Fr as useInvalidateUseGetCampaign, Lr as useInvalidateUseGetCampaignsForAgency, zr as useInvalidateUseGetProposalPresentationDetails, Vr as useInvalidateUseGetProposalPresentationSources, Ur as useInvalidateUseGetSpecialConditionBank, Gr as useInvalidateUseGetUploadedFileLink, Jr as useInvalidateUseLoadForm, oi as useInvalidateUseStaffGetAgreementDetailsForCampaign, ci as useInvalidateUseStaffGetBlankContractDetailsForCampaign, ui as useInvalidateUseStaffGetBuyers, fi as useInvalidateUseStaffGetBuyersAgent, mi as useInvalidateUseStaffGetBuyersSolicitor, gi as useInvalidateUseStaffGetCampaign, vi as useInvalidateUseStaffGetCampaignDashboard, bi as useInvalidateUseStaffGetCampaignOverview, Si as useInvalidateUseStaffGetCommissionInfoForCampaign, wi as useInvalidateUseStaffGetContract, Ei as useInvalidateUseStaffGetContractDashboard, Oi as useInvalidateUseStaffGetContractDates, Ai as useInvalidateUseStaffGetContractDeposits, Mi as useInvalidateUseStaffGetContractSettlement, Pi as useInvalidateUseStaffGetContractsForCampaign, Ii as useInvalidateUseStaffGetDocumentsForCampaign, Ri as useInvalidateUseStaffGetExternalConjunction, Vi as useInvalidateUseStaffGetLaunchDateDetailsForCampaign, Ui as useInvalidateUseStaffGetPhotosAndMediaDetailsForCampaign, Gi as useInvalidateUseStaffGetPropertyDetailsForCampaign, qi as useInvalidateUseStaffGetPropertyInformationProgressForCampaign, Yi as useInvalidateUseStaffGetSaleInformation, Zi as useInvalidateUseStaffGetSpecialConditions, $i as useInvalidateUseStaffGetTenancyInformationForCampaign, ta as useInvalidateUseStaffGetUploadedFileLink, ra as useInvalidateUseStaffGetVendorDetailsForCampaign, oa as useInvalidateUseStaffSearchForCampaign, qr as useLoadForm, Yr as useNegotiate, Xr as usePerformCampaignAction, Zr as usePerformContractAction, Qr as useRemoveFile, $r as useRemoveFormSubmission, ei as useSaveForm, ti as useSendForm, ni as useSetCampaignOwnership, ri as useStaffBeginCampaign, ii as useStaffCreateContractDepositRelease, ai as useStaffGetAgreementDetailsForCampaign, si as useStaffGetBlankContractDetailsForCampaign, li as useStaffGetBuyers, di as useStaffGetBuyersAgent, pi as useStaffGetBuyersSolicitor, hi as useStaffGetCampaign, _i as useStaffGetCampaignDashboard, yi as useStaffGetCampaignOverview, xi as useStaffGetCommissionInfoForCampaign, Ci as useStaffGetContract, Ti as useStaffGetContractDashboard, Di as useStaffGetContractDates, ki as useStaffGetContractDeposits, ji as useStaffGetContractSettlement, Ni as useStaffGetContractsForCampaign, Fi as useStaffGetDocumentsForCampaign, Li as useStaffGetExternalConjunction, zi as useStaffGetFormConfiguration, Bi as useStaffGetLaunchDateDetailsForCampaign, Hi as useStaffGetPhotosAndMediaDetailsForCampaign, Wi as useStaffGetPropertyDetailsForCampaign, Ki as useStaffGetPropertyInformationProgressForCampaign, Ji as useStaffGetSaleInformation, Xi as useStaffGetSpecialConditions, Qi as useStaffGetTenancyInformationForCampaign, ea as useStaffGetUploadedFileLink, na as useStaffGetVendorDetailsForCampaign, ia as useStaffPreviewLinkedDates, aa as useStaffSaveForm, $ as useStaffSearchForCampaign, sa as useStaffSubmitForm, ca as useStaffUpdateAgreementDetailsForCampaign, la as useStaffUpdateBlankContractDetailsForCampaign, ua as useStaffUpdateBuyers, da as useStaffUpdateBuyersAgent, fa as useStaffUpdateBuyersSolicitor, pa as useStaffUpdateCommissionInfoForCampaign, ma as useStaffUpdateContractComplianceFields, ha as useStaffUpdateContractDates, ga as useStaffUpdateContractDeposits, _a as useStaffUpdateContractSettlement, va as useStaffUpdateContractSpecialConditionDueDate, ya as useStaffUpdateContractSpecialConditions, ba as useStaffUpdateContractTermination, xa as useStaffUpdateExternalConjunction, Sa as useStaffUpdateLaunchDateForCampaign, Ca as useStaffUpdatePhotosAndMediaDetailsForCampaign, wa as useStaffUpdatePropertyDetailsForCampaign, Ta as useStaffUpdateSaleInformation, Ea as useStaffUpdateServiceFeeInfoForCampaign, Da as useStaffUpdateTenancyInformationForCampaign, Oa as useStaffUpdateVendorDetailsForCampaign, ka as useStaffWithdrawContractOffer, Aa as useSubmitForm, ja as useUpdateProposalPresentationDetails };
